import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';
import { headers } from '../../token';

import Swal from 'sweetalert2';
import ColorBox from '../ColorBox';
import QRCode from "react-qr-code";
import validateError from '../../ValidateError';
import vAdminformat from '../../adminFormat';
import SimpleSTLViewer from '../Canvas/SimpleStlViews';
import STLViewerQuot from '../Canvas/STLViewerQuot';
import getFileExtension from '../getFileExtension';
import { use } from 'react';

const server_backend = config.API_URL;

function CreateQuotation({ username }) {
    const [CustomerList, setCustomerList] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [showModalBilling, setShowModalBilling] = useState(false);
    const [showModalShipping, setShowModalShipping] = useState(false);
    const [showExistingCustomer, setShowExistingCustomer] = useState(true);
    const [STLfile, setSTLFile] = useState(null);
    const [STLfileBussiness, setSTLFileBussiness] = useState(null);
    const [customerFiles, setCustomerFile] = useState([]);
    const [fileURL, setFileURL] = useState("");
    const [getBussinessFiles, setGetBussinessFiles] = useState([]);
    const [isDropdownVisible, setIsDropdownVisible] = useState(true);
    const [materialList, setMaterialList] = useState([]);
    const [selectedMaterialColor, setSelectedMaterialColor] = useState('#FFFFFF');
    const [selectedMaterial, setSelectedMaterial] = useState(null);
    const [orderDetails, setOrderDetails] = useState([]);
    const [errors, setErrors] = useState({});
    const [ConfUpload, setConfUpload] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const [loading, setLoading] = useState(false);

    const [uploadProgress, setUploadProgress] = useState(0); //Now we just need general progress



    const [currentPrice, setCurrentPrice] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [currentDencity, setCurrentDencity] = useState(0);
    const [materialPrice, setMaterialPrice] = useState([]);
    const [fileUploadList, setFileUploadlist] = useState(false);
    const [selectModalCustomer, setSelectModalCustomer] = useState(false);
    const [createModalCustomer, setCreateModalCustomer] = useState(false);
    const [temporaryCustomer, setTemporaryCustomer] = useState([]);
    const [isUpdateJob, setIsUpdateJob] = useState(0);
    const [isPrivate, setIsPrivate] = useState(0);
    const [AliasFileName, setAliasFileName] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredFiles, setFilteredFiles] = useState([]);
    const [optionJobs, setOptionJob] = useState([]);
    const [isOpenMouldModal, setIsOpenMouldModal] = useState(false);
    const [getMouldFile, setGetMouldFile] = useState([]);

    const [activeTabId, setActiveTabId] = useState('pills-bill-info');
    const [completedTabs, setCompletedTabs] = useState([]);
    const [showOptions, setShowOptions] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [searchMouldTerm, setSearchMouldTerm] = useState('');
    const [filteredMouldFiles, setFilteredMouldFiles] = useState([]);
    const [filteredCustomerFiles, setFilteredCustomerFiles] = useState([]);
    const [company, setCompany] = useState({});
    const CHUNK_SIZE = 10240 * 10240;

    const goToTab = (tabId) => {
        //First Validation




        const requiredFields = ['name', 'country', 'address', 'city', 'lastname', 'phone'];
        const missingField = requiredFields.find(field => !formData[field]);

        if (missingField) {
            if (!orderDetails.QR) {
                const fieldNames = {
                    name: 'Customer Name',
                    country: 'Country of Residence',
                    address: 'Address',
                    city: 'City',
                };
                Swal.fire({
                    title: 'Incomplete Customer Information',
                    text: `Please complete the ${fieldNames[missingField]} field for the customer before proceeding.`,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                return;
            }
        }

        //Continue here if you have already passed all possible validations

        setActiveTabId(tabId);
        setCompletedTabs((prev) => [...new Set([...prev, tabId])]);


    };

    const isTabCompleted = (tabId) => completedTabs.includes(tabId);

    const [formData, setFormData] = useState({
        name: '',
        lastname: '',
        email: '',
        phone: '',
        phone2: '',
        address: '',
        date_estimated: (() => {
            let date = new Date();
            date.setDate(date.getDate() + 3);
            return date.toISOString().split('T')[0];
        })(),
        parts: 1,
        city: '',
        zipcode: '',
        dni: '',
        country: '',
        shipping_address: '',
        selectedAddress: 'shipping',
        address_choose: 0,
        shipping_city: '',
        shipping_zipcode: '',
        shipping_country: '',
        print_charge: 0,
        contact_fullname: '',
        contact_phone: '',
        contact_email: '',
        comment: '',
        mat_id: '',
        file_id: '',
        cust_id: 0,
        discount: 0,
        qty: 1,
        wax_qty: 0,
        volume: '',
        area: '',
        weight: '',
        dimensions: '',
        job_comment: '',
        user_transaction: username,
    });

    const [formDataCustomer, setFormDataCustomer] = useState({
        name: '',
        lastname: '',
        email: '',
        phone: '',
        phone2: '',
        date_estimated: '',
        parts: 1,
        address: '',
        city: '',
        zipcode: '',
        dni: '',
        country: '',
        shipping_address: '',
        shipping_city: '',
        shipping_zipcode: '',
        shipping_country: '',
        contact_fullname: '',
        contact_phone: '',
        address_choose: 0,
        contact_email: '',
        comment: '',
        mat_id: '',
        file_id: '',
        discount: 0,
        cust_id: 0,
        volume: '',
        area: '',
        qty: '',
        weight: '',
        dimensions: '',
        job_comment: '',
        user_transaction: username,
    });


    //store address in a temporary variable until user confirms saving it




    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState("");

    const FilterCustomer = async (value) => {
        //console.log("Unexpected error, please check")



        try {
            const response = await axios.get(`${server_backend}/customers/search?user_transaction=${username}&findby=${filterBy}&findfor=${value}&est_id=${filterStatus}`, headers);
            setCustomerList(response.data.RES_RESULT);
            console.log("Unexpected error, please check")

        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        const getCompany = async () => {
            try {
                const response = await axios.get(`${server_backend}/company/select?id=${1}`, headers);
                setCompany(response.data.RES_RESULT[0]);
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getCompany();
    }, []);

    useEffect(() => {
        const getCustomerList = async () => {
            try {
                const response = await axios.get(`${server_backend}/customers/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setCustomerList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getCustomerList();
    }, []);




    useEffect(() => {
        const getOptionJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/options_job_value/list`, headers);
                if (response.data.RES_CODE === "00") {

                    setOptionJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getOptionJob();
    }, []);

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
        FilterCustomer(e.target.value);
        setShowDropdown(true);
    };

    const handleCustomerSelect = (customer) => {
        setTemporaryCustomer(customer); //temporarily keep the client



    };

    const confirmCustomerSelect = () => {
        if (temporaryCustomer) {
            cleanParameters(); //Clean the form before selecting a client



            setSelectedCustomer(temporaryCustomer);
            setFilterValue(temporaryCustomer.name);
            getFileCustomers(temporaryCustomer.cust_ID);

            setFormData({
                qty: 1,
                wax_qty: 0,
                name: temporaryCustomer.name,
                lastname: temporaryCustomer.lastname,
                email: temporaryCustomer.email,
                phone: temporaryCustomer.phone,
                phone2: temporaryCustomer.phone2,
                discount: 0,
                selectedAddress: 'shipping',
                address_choose: 0,
                print_charge: 0,
                dni: temporaryCustomer.dni,
                address: temporaryCustomer.address,
                city: temporaryCustomer.city,
                zipcode: temporaryCustomer.zipcode,
                country: temporaryCustomer.country,
                shipping_address: temporaryCustomer.shipping_address,
                shipping_city: temporaryCustomer.shipping_city,
                shipping_zipcode: temporaryCustomer.shipping_zipcode,
                shipping_country: temporaryCustomer.shipping_country,
                contact_fullname: temporaryCustomer.contact_fullname,
                contact_phone: temporaryCustomer.contact_phone,
                contact_email: temporaryCustomer.contact_email,
                reference1: temporaryCustomer.reference1,
                reference2: temporaryCustomer.reference2,
                est_id: temporaryCustomer.est_ID,
                user_transaction: username,
                cust_id: temporaryCustomer.cust_ID
            });
            //Close the modal after confirming the selection



            closeModalCustomer();
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const getBussinessLibrary = async () => {
            try {
                const response = await axios.get(`${server_backend}/files/private/list?user_transaction=${username}`, headers);
                if (response.data.RES_CODE === "00") {

                    setGetBussinessFiles(response.data.RES_RESULT.sort((a, b) => {
                        return b.file_ID - a.file_ID;
                    }));
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getBussinessLibrary();
    }, []);

    const getBussinessLibrary = async () => {
        try {
            const response = await axios.get(`${server_backend}/files/private/list?user_transaction=${username}`, headers);

            //console.log("Unexpected error, please check")

            if (response.data.RES_CODE === "00") {

                setGetBussinessFiles(response.data.RES_RESULT.sort((a, b) => {

                    return b.file_ID - a.file_ID;

                }));
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    useEffect(() => {
        const getMaterial = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMaterialList(response.data.RES_RESULT);

                    setFormData((prevData) => ({
                        ...prevData,
                        mat_id: response.data.RES_RESULT[0].mat_ID,
                    }));
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMaterial();
    }, [formData.items]);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const getMaterialPrice = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/types/list`, headers);

                if (response.data.RES_CODE === "00") {
                    setMaterialPrice(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMaterialPrice();
    }, []);

    //These two hooks are used to correctly select the first material once the corresponding variables have been updated.


    useEffect(() => {
        if (materialList && materialList.length > 0 && formData.mat_id && !isInitialized) {
            const selectedMaterial = materialList.find(material => material.mat_ID === formData.mat_id);

            if (selectedMaterial) {
                handleMaterialSelect(selectedMaterial);
                setSelectedMaterialColor(selectedMaterial.color);
                setCurrentDencity(selectedMaterial.density);

                setIsInitialized(true);
            }
        }
    }, [materialList, formData.mat_id, isInitialized, formData.qty]); //Dependency in format.mat_id


    useEffect(() => {
        if (isInitialized && selectedMaterial) {
            //const vw = formData.weight *selectedMaterial.density;



            const vw = formData.volume;
            const price = calculatePrice(selectedMaterial.formula, vw, materialPrice);

            if (price >= 0) {
                setCurrentPrice(parseFloat(price && price.toFixed(2)));
            }

        }
    }, [formData.weight, selectedMaterial, isInitialized]);
    //End


    const getFileCustomers = async (customerID) => {
        try {
            const response = await axios.get(`${server_backend}/customers/files/list?id=${customerID}`, headers);

            if (response.data.RES_CODE === "00") {
                setCustomerFile(response.data.RES_RESULT);

            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    //Show address Modal


    const handleOpenBillingModal = () => setShowModalBilling(true);
    const handleCloseBillingModal = () => setShowModalBilling(false);

    const handleOpenShippingModal = () => setShowModalShipping(true);
    const handleCloseShippingModal = () => setShowModalShipping(false);

    const handleBillingSubmit = (e) => {
        e.preventDefault();
        setShowModalBilling(false);
    };

    const handleShippingSubmit = (e) => {
        e.preventDefault();
        setShowModalShipping(false);
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(files); //store all selected files



    };

    const handleFileSelect = (File) => {
        console.log("Unexpected error, please check")
        setSTLFileBussiness(File);
        //Set file url(file.path file);



        setIsDropdownVisible(false);
    };

    const handleMaterialSelect = (material) => {
        setSelectedMaterial(material);
        setFormData({ ...formData, mat_id: material.mat_ID });
        setShowDropdown(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    const formatStats = (stats) => {
        const formatNumber = (num, decimals) => num.toFixed(decimals);

        const volume = formatNumber(stats.volume / 1000, 2);
        const area = formatNumber(stats.area / 100, 2);
        const weight = formatNumber(stats.weight / 1000, 2);

        const dimensions = {
            x: formatNumber(stats.dimensions.x / 10, 2),
            y: formatNumber(stats.dimensions.y / 10, 2),
            z: formatNumber(stats.dimensions.z / 10, 2)
        };

        stats.volume = volume;
        stats.area = area;
        stats.weight = weight;
        stats.file_id = STLfileBussiness.file_ID;
        stats.dimensions = `${dimensions.x} x ${dimensions.y} x ${dimensions.z} cm`;
        //console.log("Unexpected error, please check")
        //setFormData({volume: ...volume});



        return stats;

        /*return {
            volume: `${volume} cm³`,
            area: `${area} cm²`,
            weight: `${weight} g`,
            dimensions: `${dimensions.x} x ${dimensions.y} x ${dimensions.z} cm`
        }; */
    };

    const handleStatsUpdate = (stats) => {
        const formattedStats = formatStats(stats);
        //console.log("Unexpected error, please check")



        setFormData(formattedStats);
    };

    const InsertQuotations = async (e) => {

        setOrderDetails([]) //To clean order details (qrcode)

        e.preventDefault();
        //console.log("Unexpected error, please check")

        if (formData.address_choose === 1) {
            formData.address = formData.shipping_address;
            formData.city = formData.shipping_city;
            formData.zipcode = formData.shipping_zipcode;
            formData.country = formData.shipping_country;

        } else if (formData.address_choose === 2) {
            formData.address = company.address;
            formData.city = company.city;
            formData.zipcode = company.zipcode;
            formData.country = company.country;
        }

        try {
            const response = await axios.post(`${server_backend}/quotations/insert`, formData, headers);
            //console.log("Unexpected error, please check")
            if (response.data.RES_CODE === "00") {
                setOrderDetails(response.data.RES_RESULT);
                Swal.fire({
                    icon: 'success',
                    title: 'Created Successfully',
                    showConfirmButton: false,
                    timer: 2000
                });
                //Navigate('/customers');



                goToTab('pills-finish');
                setFormData({
                    name: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    phone2: '',
                    address: '',
                    city: '',
                    zipcode: '',
                    dni: '',
                    country: '',
                    shipping_address: '',
                    shipping_city: '',
                    shipping_zipcode: '',
                    shipping_country: '',
                    contact_fullname: '',
                    contact_phone: '',
                    address_choose: 0,
                    contact_email: '',
                    comment: '',
                    mat_id: '',
                    file_id: '',
                    cust_id: 0,
                    qty: 1,
                    wax_qty: 0,
                    volume: '',
                    area: '',
                    weight: '',
                    dimensions: '',
                    job_comment: '',
                    user_transaction: username,
                })

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'quotation already exists, please try another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    };

    const handleUploadFileModal = async () => {
        if (selectedFiles.length === 0) return;

        setIsUploading(true); //We activate the progress bar



        const uploadedFiles = []; //store the names of the uploaded files



        const totalFiles = selectedFiles.length; //Total file number



        let globalProgress = 0; //Total accumulated progress




        for (const file of selectedFiles) {
            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            let fileName = file.name; //Original file name




            try {
                //Verify if the file already exists



                try {
                    const checkResponse = await axios.get(
                        `${server_backend}/files/private/exists?name=${file.name}`,
                        headers
                    );

                    if (checkResponse.data.RES_CODE === "00") {
                        //If it exists, generate a unique alias



                        const now = new Date();
                        const formattedDate = now.toISOString().replace(/[-:.TZ]/g, "");
                        const fileExtension = file.name.split(".").pop();
                        const fileBaseName = file.name.replace(`.${fileExtension}`, "");

                        fileName = `${fileBaseName}_${formattedDate}.${fileExtension}`;
                    }
                } catch (error) {
                    console.log("Unexpected error, please check")
                }

                for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                    const start = chunkIndex * CHUNK_SIZE;
                    const end = Math.min(start + CHUNK_SIZE, file.size);
                    const chunk = file.slice(start, end);

                    const formData = new FormData();
                    formData.append("chunk", chunk);
                    formData.append("chunkIndex", chunkIndex);
                    formData.append("totalChunks", totalChunks);
                    formData.append("name", fileName);
                    formData.append("user_transaction", username);

                    const uploadConfig = {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: headers.headers.Authorization,
                        },
                        onUploadProgress: (progressEvent) => {
                            const percentPerFile =
                                ((chunkIndex + 1) / totalChunks) * (100 / totalFiles); //Progress relative to the current file



                            globalProgress = Math.min(
                                globalProgress + percentPerFile,
                                100
                            ); //We assure that it does not exceed 100%



                            setUploadProgress(Math.round(globalProgress));
                        },
                    };

                    try {
                        const uploadResponse = await axios.post(
                            `${server_backend}/files/private/insert`,
                            formData,
                            uploadConfig
                        );

                        if (uploadResponse.data.RES_CODE === "00") {
                            //We left the loop if the fragment climbed successfully



                            break;
                        }
                    } catch (uploadError) {
                        console.log("Unexpected error, please check")
                        Swal.fire({
                            icon: "error",
                            title: "Error uploading file",
                            text: `There was an issue uploading ${fileName}.`,
                            showConfirmButton: false,
                            timer: 2000,
                        });
                        setIsUploading(false);
                        setUploadProgress(0);
                        return;
                    }
                }

                //We add the file successfully uploaded to the list



                uploadedFiles.push(fileName);
            } catch (error) {
                console.log("Unexpected error, please check")
            } finally {
                getBussinessLibrary(); //Update the library after loading



            }
        }

        setAliasFileName(uploadedFiles); //We keep all the names of uploaded files



        setConfUpload(true);
        setIsUploading(false);
        setUploadProgress(100); //We assure that progress reaches 100%



    };

    const calculatePrice = (formula, formDataWeight, materialPrice) => {
        console.log("Unexpected error, please check")

        if (!formula || formula.trim() === '') return null;

        let processedFormula = formula.replace(/{weight}/g, parseFloat(formDataWeight));

        materialPrice.forEach((material) => {
            const variableName = material.name.toLowerCase();
            const materialPriceValue = parseFloat(material.lastprice);
            if (!isNaN(materialPriceValue)) {
                processedFormula = processedFormula.replace(new RegExp(`{${variableName}}`, 'g'), materialPriceValue);
                console.log("Unexpected error, please check")
            } else {
                console.warn(`Price not valid for ${material.name}`);
            }
        });

        console.log("Unexpected error, please check")

        console.log("Unexpected error, please check")

        try {
            const price = new Function(`return (${processedFormula})`)();
            console.log("Unexpected error, please check")
            return price;
        } catch (error) {
            console.log("Unexpected error, please check")
            console.log("Unexpected error, please check")
            return null;
        }
    };

    const addFileToItems = () => {

        const newItem = {
            volume: formData.volume,
            parts: formData.parts || 1,
            date_estimated: formData.date_estimated || new Date().toISOString().slice(0, 16),
            area: formData.area,
            materials_color: formData.materials_color || selectedMaterialColor,
            weight: formData.weight,
            dimensions: formData.dimensions,
            job_comment: formData.job_comment,
            file_id: formData.file_id,
            mat_id: selectedMaterial.mat_ID,
            price: currentPrice,
            discount: formData.discount,
            total: (currentPrice * formData.qty) - (formData.discount || 0),
            qty: formData.qty ? formData.qty : 1,
            file_private: isPrivate,
            mount: currentPrice,
            filename: STLfileBussiness.name,
            materialname: selectedMaterial.name,
            urlfile: fileURL,
            designate: formData.designate,
            print_type: formData.print_type || 0,
            discount_ptg: formData.discount_ptg || 0,
            moulding: formData.moulding || 0,
            mould_only: formData.mould_only || 0,
            sprue_master: formData.sprue_master || 0,
            sprue_material: formData.sprue_material || 0,
            sprue_feed: formData.sprue_feed || 0,
            post: formData.post || 0,
            wax_qty: formData.wax_qty || 0,
            print_charge: formData.print_charge || 0,
        };
        //console.log("Unexpected error, please check")




        setFormData(prevState => ({
            ...prevState,
            items: Array.isArray(prevState.items) ? [...prevState.items, newItem] : [newItem],
            volume: '',
            area: '',
            weight: '',
            dimensions: '',
            job_comment: '',
            file_id: '',
            mat_id: ''
        }));

        setSelectedMaterial(null);
        setSTLFileBussiness([]);
        setSTLFile(null);
        setSelectedFiles([]);
        setFileURL("")
        closeModalFile();
        setIsInitialized(false); //This will cause the object to be selected with the first material automatically




    };

    const addMouldToItems = () => {

        const newItem = {
            volume: formData.volume,
            parts: formData.parts || 1,
            date_estimated: formData.date_estimated || new Date().toISOString().slice(0, 16),
            area: formData.area,
            weight: formData.weight,
            materials_color: formData.materials_color || selectedMaterialColor,
            dimensions: formData.dimensions,
            job_comment: formData.job_comment,
            file_id: STLfileBussiness?.file_ID,
            mat_id: selectedMaterial.mat_ID,
            price: currentPrice,
            discount: formData.discount,
            total: (currentPrice * formData.qty) - (formData.discount || 0),
            qty: formData.qty ? formData.qty : 1,
            file_private: 1,
            mount: currentPrice,
            filename: STLfileBussiness?.name,
            materialname: selectedMaterial.name,
            urlfile: fileURL,
            designate: formData.designate,
            print_type: formData.print_type || 0,
            discount_ptg: formData.discount_ptg || 0,
            moulding: formData.moulding || 0,
            mould_only: formData.mould_only || 0,
            sprue_master: formData.sprue_master || 0,
            sprue_material: formData.sprue_material || 0,
            sprue_feed: formData.sprue_feed || 0,
            post: formData.post || 0,
            wax_qty: formData.wax_qty || 0,
            print_charge: formData.print_charge || 0,
            mould_name: STLfileBussiness?.mould_name,
            mould_type: STLfileBussiness?.mould_type,
            mould_description: STLfileBussiness?.comment,
            date_created: STLfileBussiness?.date_created,
        };
        //console.log("Unexpected error, please check")



        setFormData(prevState => ({
            ...prevState,
            moulds: Array.isArray(prevState.moulds) ? [...prevState.moulds, newItem] : [newItem],
            volume: '',
            area: '',
            weight: '',
            dimensions: '',
            job_comment: '',
            file_id: '',
        }));

        //Set selected material(null);



        setSTLFileBussiness([]);
        setSTLFile(null);
        setSelectedFiles([]);
        setFileURL("")
        closeMouldModal();
        setIsInitialized(false); //This will cause the object to be selected with the first material automatically


    };

    const handleDecreaseQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            qty: Math.max(prevState.qty > 1 ? prevState.qty - 1 : 1)
        }));
    };

    const handleIncreaseQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            qty: prevState.qty ? prevState.qty + 1 : 1
        }));
    };

    const handleDecreaseWaxQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            wax_qty: Math.max(prevState.wax_qty > 1 ? prevState.wax_qty - 1 : 0)
        }));
    };

    const handleIncreaseWaxQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            wax_qty: prevState.wax_qty ? prevState.wax_qty + 1 : 1
        }));
    };

    const handleCommentChange = (e, index) => {
        const newComment = e.target.value;
        const updatedItems = [...formData.items];
        updatedItems[index].job_comment = newComment;

        setFormData({
            ...formData,
            items: updatedItems
        });
    };

    const handleCommentMouldChange = (e, index) => {
        const newComment = e.target.value;
        const updatedItems = [...formData.moulds];
        updatedItems[index].job_comment = newComment;

        setFormData({
            ...formData,
            moulds: updatedItems
        });
    };

    const handleDelete = (index) => {
        const updatedItems = formData.items.filter((_, itemIndex) => itemIndex !== index);
        setFormData({ ...formData, items: updatedItems });
    };

    const handleDeleteMould = (index) => {
        const updatedItems = formData.moulds.filter((_, itemIndex) => itemIndex !== index);
        setFormData({ ...formData, moulds: updatedItems });
    };

    const OpenModalFile = () => {
        setFormData({
            ...formData,
            date_estimated: (() => {
                let date = new Date();
                date.setDate(date.getDate() + 3);
                return date.toISOString().split('T')[0];
            })(),
            designate: '',
            qty: 1,
            print_type: '',
            discount_ptg: '',
            job_comment: '',
            moulding: '',
            mould_only: '',
            sprue_master: '',
            sprue_material: '',
            sprue_feed: '',
            post: '',
            print_charge: '',
            wax_qty: 0,
        });
        setFileUploadlist(true);
    }

    const closeModalFile = () => {
        setFileUploadlist(false);
        setSearchTerm('');
    }

    const OpenMouldModal = () => {
        setFormData({
            ...formData,
            date_estimated: (() => {
                let date = new Date();
                date.setDate(date.getDate() + 3);
                return date.toISOString().split('T')[0];
            })(),
            designate: '',
            qty: 1,
            print_type: '',
            discount_ptg: '',
            job_comment: '',
            moulding: '',
            mould_only: '',
            sprue_master: '',
            sprue_material: '',
            sprue_feed: '',
            post: '',
            print_charge: '',
            wax_qty: 0,
        });
        getMouldLibrary();
        setIsOpenMouldModal(true);
    }

    const closeMouldModal = () => {
        setIsOpenMouldModal(false);
        setSearchTerm('');
    }

    const showModalCustomer = () => {
        setSelectModalCustomer(true);
    }

    const closeModalCustomer = () => {
        setSelectModalCustomer(false);
    }

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const openCreateModalCustomer = () => {
        setCreateModalCustomer(true);
        //cleanParameters() //clean parametres is importan to formData



    }

    const closeCreateModalCustomer = () => {
        setCreateModalCustomer(false)
    }

    function cleanParameters() {
        setFormDataCustomer({
            address: "",
            area: "",
            city: "",
            comment: "",
            contact_email: "",
            contact_fullname: "",
            contact_phone: "",
            country: "",
            cust_id: "",
            dimensions: "",
            dni: "",
            email: "",
            est_id: "",
            file_id: "",
            items: [],
            job_comment: "",
            lastname: "",
            qty: 1,
            mat_id: "",
            name: "",
            phone: "",
            phone2: "",
            reference1: "",
            reference2: "",
            selectedAddress: "",
            shipping_address: "",
            shipping_city: "",
            shipping_country: "",
            shipping_zipcode: "",
            user_transaction: "",
            volume: "",
            weight: "",
            zipcode: ""
        });
    }

    const handleCreate = async (e) => {
        e.preventDefault();

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to create this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                try {
                    const response = await axios.post(`${server_backend}/Customers/insert`, formDataCustomer, headers);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Created Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });


                        const data = response.data.RES_RESULT;
                        setFormData({ ...formDataCustomer, cust_id: data.ID });
                        cleanParameters()
                        closeCreateModalCustomer();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Customer already exists, please try another name',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 5000
                    });
                } finally {
                    setLoading(false);
                }
            }
        })

    };

    const handlePriceChange = (e) => {
        const value = e.target.value;

        const cleanValue = value.replace(/[^0-9.]/g, '');

        if ((cleanValue.match(/\./g) || []).length <= 1) {
            setCurrentPrice(parseFloat(cleanValue));
        }
    };

    useEffect(() => {
        const now = new Date();
        const formattedDateTime = now.toISOString().slice(0, 16); //Get current date and time in YYYY-MM-DDTHH:MM format



        setFormData({ ...formData, date_estimated: formattedDateTime });
    }, []);


    useEffect(() => {
        if (getBussinessFiles && getBussinessFiles.length > 0) {
            const filtered = getBussinessFiles.filter(file =>
                file.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredFiles(filtered);
        } else {
            setFilteredFiles([]);
        }
    }, [searchTerm, getBussinessFiles]);

    useEffect(() => {
        if (customerFiles && customerFiles.length > 0) {
            const filtered = customerFiles.filter(file =>
                file.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredCustomerFiles(filtered);
        } else {
            setFilteredCustomerFiles([]);
        }
    }, [searchTerm, customerFiles]);

    useEffect(() => {
        if (getMouldFile && getMouldFile.length > 0) {
            const filtered = getMouldFile.filter(file =>
                file.mould_name.toLowerCase().includes(searchMouldTerm.toLowerCase())
            );
            setFilteredMouldFiles(filtered);
        } else {
            setFilteredMouldFiles([]);
        }
    }, [searchMouldTerm, getMouldFile]);

    const getMouldLibrary = async () => {
        try {
            const response = await axios.get(`${server_backend}/files/moulds/private/list`, headers);
            //console.log("Unexpected error, please check")



            if (response.data.RES_CODE === "00") {
                setGetMouldFile(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }



    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0">Checkout</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="javascript: void(0);">Sales</a></li>
                                    <li className="breadcrumb-item active">Quotations</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body checkout-tab">
                                <form action="#">
                                    <div className="step-arrow-nav mt-n3 mx-n3 mb-3">
                                        <ul className="nav nav-pills nav-justified custom-nav" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className={`nav-link fs-15 p-3 ${activeTabId === 'pills-bill-info' ? 'active' : ''} ${isTabCompleted('pills-bill-info') ? 'completed' : ''}`}
                                                    id="pills-bill-info-tab"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="pills-bill-info"
                                                    aria-selected={activeTabId === 'pills-bill-info'}
                                                    onClick={() => goToTab('pills-bill-info')}
                                                >
                                                    <i className="ri-user-2-line fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>
                                                    Personal Info
                                                </button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className={`nav-link fs-15 p-3 ${activeTabId === 'pills-bill-address' ? 'active' : ''} ${isTabCompleted('pills-bill-address') ? 'completed' : ''}`}
                                                    id="pills-bill-address-tab"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="pills-bill-address"
                                                    aria-selected={activeTabId === 'pills-bill-address'}
                                                    onClick={() => goToTab('pills-bill-address')}
                                                >
                                                    <i className="ri-truck-line fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>
                                                    Shipping Info
                                                </button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className={`nav-link fs-15 p-3 ${activeTabId === 'pills-payment' ? 'active' : ''} ${isTabCompleted('pills-payment') ? 'completed' : ''}`}
                                                    id="pills-payment-tab"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="pills-payment"
                                                    aria-selected={activeTabId === 'pills-payment'}
                                                    onClick={() => {
                                                        if (!formData.selectedAddress) {
                                                            Swal.fire({
                                                                icon: 'error',
                                                                title: 'You need to select an address before continuing the process',
                                                                showConfirmButton: false,
                                                                timer: 2000
                                                            });
                                                            return;
                                                        }

                                                        if (formData.address_choose || formData.address_choose >= 0) {

                                                            if (formData.address_choose === 0) {
                                                                if (!formData.address || formData.address === '') {
                                                                    Swal.fire({
                                                                        icon: 'error',
                                                                        title: 'You must select or register an address',
                                                                        showConfirmButton: false,
                                                                        timer: 2000
                                                                    });
                                                                    return;
                                                                }
                                                                if (!formData.city || formData.city === '') {
                                                                    Swal.fire({
                                                                        icon: 'error',
                                                                        title: 'You must select or register an address',
                                                                        showConfirmButton: false,
                                                                        timer: 2000
                                                                    });
                                                                    return;
                                                                }

                                                                if (!formData.country || formData.country === '') {
                                                                    Swal.fire({
                                                                        icon: 'error',
                                                                        title: 'You must select or register an address',
                                                                        showConfirmButton: false,
                                                                        timer: 2000
                                                                    });
                                                                    return;
                                                                }

                                                            }

                                                            if (formData.address_choose === 1) {
                                                                if (!formData.shipping_address || formData.shipping_address === '') {
                                                                    Swal.fire({
                                                                        icon: 'error',
                                                                        title: 'You must select or register an address',
                                                                        showConfirmButton: false,
                                                                        timer: 2000
                                                                    });
                                                                    return;
                                                                }
                                                                if (!formData.shipping_city || formData.shipping_city === '') {
                                                                    Swal.fire({
                                                                        icon: 'error',
                                                                        title: 'You must select or register an address',
                                                                        showConfirmButton: false,
                                                                        timer: 2000
                                                                    });
                                                                    return;
                                                                }

                                                                if (!formData.shipping_country || formData.shipping_country === '') {
                                                                    Swal.fire({
                                                                        icon: 'error',
                                                                        title: 'You must select or register an address',
                                                                        showConfirmButton: false,
                                                                        timer: 2000
                                                                    });
                                                                    return;
                                                                }

                                                            }

                                                            goToTab('pills-payment')
                                                        } else {
                                                            Swal.fire({
                                                                icon: 'error',
                                                                title: 'You must select or register an address',
                                                                showConfirmButton: false,
                                                                timer: 2000
                                                            });
                                                        }
                                                    }}
                                                >
                                                    <i className="ri-upload-2-fill fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>
                                                    File
                                                </button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className={`nav-link fs-15 p-3 ${activeTabId === 'pills-summary' ? 'active' : ''} ${isTabCompleted('pills-summary') ? 'completed' : ''}`}
                                                    id="pills-summary-tab"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="pills-summary"
                                                    aria-selected={activeTabId === 'pills-summary'}
                                                    onClick={() => {

                                                        const hasItems = formData.items?.length > 0;
                                                        const hasMoulds = formData.moulds?.length > 0;

                                                        if (hasItems || hasMoulds) {
                                                            goToTab('pills-summary');
                                                        } else {
                                                            Swal.fire({
                                                                icon: 'error',
                                                                title: 'You must select an STL file or a mould to see the summary and complete the order.',
                                                                showConfirmButton: false,
                                                                timer: 2000
                                                            });
                                                        }

                                                    }
                                                    }
                                                >
                                                    <i className="ri-book-2-fill fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>
                                                    Summary
                                                </button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className={`nav-link fs-15 p-3 ${activeTabId === 'pills-finish' ? 'active' : ''} ${isTabCompleted('pills-finish') ? 'completed' : ''}`}
                                                    id="pills-finish-tab"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="pills-finish"
                                                    aria-selected={activeTabId === 'pills-finish'}
                                                    onClick={() => {
                                                        if (orderDetails.ID) {
                                                            goToTab('pills-finish')
                                                        } else {
                                                            Swal.fire({
                                                                icon: 'error',
                                                                title: 'you must confirm the order by selecting the complete order button in the summary',
                                                                showConfirmButton: false,
                                                                timer: 2000
                                                            });
                                                        }

                                                    }
                                                    }
                                                >
                                                    <i className="ri-checkbox-circle-line fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>
                                                    Finish
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="tab-content">

                                        <div className={`tab-pane fade ${activeTabId === 'pills-bill-info' ? 'show active' : ''}`}
                                            id="pills-bill-info"
                                            role="tabpanel"
                                            aria-labelledby="pills-bill-info-tab"
                                            style={{ minHeight: "60vh" }}>
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div>
                                                    <p className="text-muted mb-0">Please fill all information below</p>
                                                </div>

                                                <div>
                                                    <button className='btn btn-secondary' onClick={showModalCustomer} type='button' style={{ marginRight: "5px" }}> <i className='mdi mdi-account-plus-outline ffs'></i> Select a customer here</button>
                                                    <button type="button" className="btn btn-success" onClick={() => {
                                                        //Clean Parameters ()



                                                        openCreateModalCustomer()
                                                    }
                                                    }>
                                                        New Customer
                                                    </button>
                                                </div>
                                            </div>


                                            {formData.name ? (
                                                <div className="mb-3">
                                                    <center><h5 className="mb-3">Customer selected</h5></center>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="mb-3">
                                                                <label htmlFor="billinginfo-firstName-disabled" className="form-label">Customer ID</label>
                                                                <input
                                                                    type="text"
                                                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                                    id="billinginfo-firstName-disabled"
                                                                    maxLength="50"
                                                                    value={formData.cust_id}
                                                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                                                    disabled
                                                                />
                                                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="mb-3">
                                                                <label htmlFor="billinginfo-firstName-disabled" className="form-label">First Name</label>
                                                                <input
                                                                    type="text"
                                                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                                    id="billinginfo-firstName-disabled"
                                                                    maxLength="50"
                                                                    value={formData.name}
                                                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                                                    disabled
                                                                />
                                                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="mb-3">
                                                                <label htmlFor="billinginfo-lastName-disabled" className="form-label">Last Name</label>
                                                                <input
                                                                    type="text"
                                                                    className={`form-control ${errors.lastname ? 'is-invalid' : ''}`}
                                                                    id="billinginfo-lastName-disabled"
                                                                    maxLength="50"
                                                                    value={formData.lastname}
                                                                    onChange={(e) => setFormData({ ...formData, lastname: e.target.value })}
                                                                    disabled
                                                                />
                                                                {errors.lastname && <div className="invalid-feedback">{errors.lastname}</div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="mb-3">
                                                                <label htmlFor="billinginfo-email-disabled" className="form-label">Email</label>
                                                                <input
                                                                    type="email"
                                                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                                    id="billinginfo-email-disabled"
                                                                    placeholder="Email"
                                                                    maxLength="256"
                                                                    value={formData.email}
                                                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                                                    disabled
                                                                />
                                                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="mb-3">
                                                                <label htmlFor="billinginfo-phone-disabled" className="form-label">Phone</label>
                                                                <input
                                                                    type="text"
                                                                    className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                                                    id="billinginfo-phone-disabled"
                                                                    maxLength="50"
                                                                    value={formData.phone}
                                                                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                                                />
                                                                {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="billinginfo-address-disabled" className="form-label">Address</label>
                                                        <textarea
                                                            className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                                                            id="billinginfo-address-disabled"
                                                            rows="3"
                                                            maxLength="256"
                                                            value={formData.address}
                                                            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                                        ></textarea>
                                                        {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="country-disabled" className="form-label">Country</label>
                                                                <input
                                                                    type="text"
                                                                    className={`form-control ${errors.country ? 'is-invalid' : ''}`}
                                                                    id="country-disabled"
                                                                    maxLength="50"
                                                                    value={formData.country}
                                                                    onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                                                                />
                                                                {errors.country && <div className="invalid-feedback">{errors.country}</div>}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="state-disabled" className="form-label">City</label>
                                                                <input
                                                                    type="text"
                                                                    className={`form-control ${errors.city ? 'is-invalid' : ''}`}
                                                                    id="state-disabled"
                                                                    value={formData.city}
                                                                    maxLength="50"
                                                                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                                                                />
                                                                {errors.city && <div className="invalid-feedback">{errors.city}</div>}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="zip-disabled" className="form-label">Post Code</label>
                                                                <input
                                                                    type="text"
                                                                    className={`form-control ${errors.zipcode ? 'is-invalid' : ''}`}
                                                                    id="zip-disabled"
                                                                    value={formData.zipcode}
                                                                    maxLength="50"
                                                                    onChange={(e) => setFormData({ ...formData, zipcode: e.target.value })}
                                                                />
                                                                {errors.zipcode && <div className="invalid-feedback">{errors.zipcode}</div>}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            ) : (
                                                <center>
                                                    <h5 className='text-muted'>No customer has been selected yet</h5>
                                                </center>
                                            )}

                                            {formData.name && (
                                                <div className="d-flex align-items-start gap-3 mt-auto">
                                                    <button type="button" className="btn btn-primary btn-label right ms-auto"
                                                        onClick={() => goToTab('pills-bill-address')}>
                                                        <i className="ri-bank-card-line label-icon align-middle fs-16 ms-2"></i>
                                                        Continue to Shipping Info
                                                    </button>
                                                </div>
                                            )}

                                        </div>

                                        <div className={`tab-pane fade ${activeTabId === 'pills-bill-address' ? 'show active' : ''}`}
                                            id="pills-bill-address"
                                            role="tabpanel"
                                            aria-labelledby="pills-bill-address-tab">
                                            <div className="mt-5">
                                                <div className="d-flex align-items-center mb-4">
                                                    <div className="flex-grow-1">
                                                        <h4 className="fw-bold mb-0">Choose Delivery Option</h4>
                                                        <p className="text-muted small">Select how you would like to receive your order</p>
                                                    </div>
                                                </div>

                                                <div className="row gy-4 mb-5">
                                                    {/* Shipping Address */}
                                                    <div className="col-md-6">
                                                        <div className="form-check card-radio shadow-sm border rounded-3 h-100">
                                                            <input
                                                                id="shippingAddress02"
                                                                name="addressOption"
                                                                type="radio"
                                                                className="form-check-input d-none"
                                                                checked={formData.selectedAddress === "shipping"}
                                                                onChange={() =>
                                                                    setFormData({
                                                                        ...formData,
                                                                        selectedAddress: "shipping",
                                                                        address_choose: 1,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label p-3 d-block h-100"
                                                                htmlFor="shippingAddress02"
                                                            >
                                                                <h6 className="text-uppercase fw-semibold mb-3 text-primary">
                                                                    Shipping Address
                                                                </h6>
                                                                <div className="text-muted small">
                                                                    <p className="mb-1">{formData.shipping_address}</p>
                                                                    <p className="mb-1">{formData.shipping_city}</p>
                                                                    <p className="mb-1">{formData.shipping_country}</p>
                                                                    <p className="mb-0">{formData.shipping_zipcode}</p>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div className="text-end mt-2">
                                                            <a
                                                                href="#"
                                                                className="text-decoration-none small text-primary"
                                                                onClick={handleOpenShippingModal}
                                                            >
                                                                <i className="ri-pencil-fill me-1"></i> Edit
                                                            </a>
                                                        </div>
                                                    </div>

                                                    {/* Collection Option */}
                                                    <div className="col-md-6">
                                                        <div className="form-check card-radio shadow-sm border rounded-3 h-100">
                                                            <input
                                                                id="collectionOption03"
                                                                name="addressOption"
                                                                type="radio"
                                                                className="form-check-input d-none"
                                                                checked={formData.selectedAddress === "collection"}
                                                                onChange={() =>
                                                                    setFormData({
                                                                        ...formData,
                                                                        selectedAddress: "collection",
                                                                        address_choose: 2,
                                                                    })
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label p-3 d-block h-100"
                                                                htmlFor="collectionOption03"
                                                            >
                                                                <h6 className="text-uppercase fw-semibold mb-3 text-warning">
                                                                    Collection (Pick Up)
                                                                </h6>
                                                                <div className="text-muted small">
                                                                    <p className="mb-1">Collect directly from our office</p>
                                                                    <p className="mb-0">{company.address}, {company.city}, {company.country}</p>
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>


                                            <div className="d-flex align-items-start gap-3 mt-4">
                                                <button type="button" className="btn btn-light btn-label " onClick={() => goToTab('pills-bill-info')}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" ></i>Back
                                                    to Personal Info</button>
                                                <button type="button" class="btn btn-primary btn-label right ms-auto" onClick={() => {
                                                    if (!formData.selectedAddress) {
                                                        Swal.fire({
                                                            icon: 'error',
                                                            title: 'You need to select an address before continuing the process',
                                                            showConfirmButton: false,
                                                            timer: 2000
                                                        });
                                                        return;
                                                    }

                                                    if (formData.address_choose || formData.address_choose >= 0) {

                                                        if (formData.address_choose === 0) {
                                                            if (!formData.address || formData.address === '') {
                                                                Swal.fire({
                                                                    icon: 'error',
                                                                    title: 'You must select or register an address',
                                                                    showConfirmButton: false,
                                                                    timer: 2000
                                                                });
                                                                return;
                                                            }
                                                            if (!formData.city || formData.city === '') {
                                                                Swal.fire({
                                                                    icon: 'error',
                                                                    title: 'You must select or register an address',
                                                                    showConfirmButton: false,
                                                                    timer: 2000
                                                                });
                                                                return;
                                                            }

                                                            if (!formData.country || formData.country === '') {
                                                                Swal.fire({
                                                                    icon: 'error',
                                                                    title: 'You must select or register an address',
                                                                    showConfirmButton: false,
                                                                    timer: 2000
                                                                });
                                                                return;
                                                            }

                                                        }

                                                        if (formData.address_choose === 1) {
                                                            if (!formData.shipping_address || formData.shipping_address === '') {
                                                                Swal.fire({
                                                                    icon: 'error',
                                                                    title: 'You must select or register an address',
                                                                    showConfirmButton: false,
                                                                    timer: 2000
                                                                });
                                                                return;
                                                            }
                                                            if (!formData.shipping_city || formData.shipping_city === '') {
                                                                Swal.fire({
                                                                    icon: 'error',
                                                                    title: 'You must select or register an address',
                                                                    showConfirmButton: false,
                                                                    timer: 2000
                                                                });
                                                                return;
                                                            }

                                                            if (!formData.shipping_country || formData.shipping_country === '') {
                                                                Swal.fire({
                                                                    icon: 'error',
                                                                    title: 'You must select or register an address',
                                                                    showConfirmButton: false,
                                                                    timer: 2000
                                                                });
                                                                return;
                                                            }

                                                        }

                                                        goToTab('pills-payment')
                                                    } else {
                                                        Swal.fire({
                                                            icon: 'error',
                                                            title: 'You must select or register an address',
                                                            showConfirmButton: false,
                                                            timer: 2000
                                                        });
                                                    }

                                                }}><i className="ri-bank-card-line label-icon align-middle fs-16 ms-2"></i>Continue
                                                    to Files</button>
                                            </div>
                                        </div>

                                        <div className={`tab-pane fade ${activeTabId === 'pills-payment' ? 'show active' : ''}`}
                                            id="pills-payment"
                                            role="tabpanel"
                                            aria-labelledby="pills-payment-tab">

                                            <div className="row">
                                                <div className="col-lg-12">
                                                    {isUploading ? (
                                                        <div className="progress mb-4">
                                                            <div
                                                                className="progress-bar progress-bar-striped progress-bar-animated"
                                                                role="progressbar"
                                                                aria-valuenow={uploadProgress}
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                                style={{ width: `${uploadProgress}%` }}
                                                            >
                                                                {uploadProgress}%
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {/* Tables below buttons */}
                                                    <div className="mt-5">
                                                        <h5 className="mb-3">📁 STL Files</h5>
                                                        <div className="row">

                                                            {formData.items && formData.items.length > 0 ? (
                                                                <>
                                                                    {/* Map through STL items */}
                                                                    {formData.items && formData.items.length > 0 && formData.items.map((item, index) => (
                                                                        <div key={`item-${index}`} className="col-md-3 col-lg-3 mb-4">
                                                                            <div className="card h-100 shadow-sm">
                                                                                <div
                                                                                    className="card-header d-flex justify-content-between align-items-center bg-light" style={{ height: "10vh", maxHeight: "10vh" }}>
                                                                                    <span >#{index + 1} - {vAdminformat.truncateText(item.filename, 15)}</span>
                                                                                    <button type='button' className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(index)}>
                                                                                        <i className="bx bx-trash"></i>
                                                                                    </button>
                                                                                </div>
                                                                                <div className="card-body">
                                                                                    <div className="col-12">
                                                                                        <div className="row">
                                                                                            <div className="col-6">
                                                                                                <div className="text-center mb-3" style={{ height: "13vh" }}>
                                                                                                    <SimpleSTLViewer url={item.urlfile} currentColor={item.materials_color} />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="col-6">
                                                                                                <ul className="list-unstyled small">
                                                                                                    <li><strong>Material:</strong> {item.materialname}</li>
                                                                                                    <li><strong>Quantity:</strong> {item.qty}</li>
                                                                                                </ul>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <ul className="list-unstyled small">
                                                                                        <li><strong>Price:</strong> {vAdminformat.FormatMoney(item.price)}</li>
                                                                                        <li><strong>Discount:</strong> {vAdminformat.FormatMoney(item.discount)}</li>
                                                                                        <li className="fw-bold"><strong>Total:</strong> {vAdminformat.FormatMoney(item.total + parseFloat(formData.print_charge))}</li>
                                                                                    </ul>
                                                                                    <textarea
                                                                                        value={item.job_comment}
                                                                                        onChange={(e) => handleCommentChange(e, index)}
                                                                                        className="form-control mt-2"
                                                                                        placeholder="Add instructions"
                                                                                        rows={2}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </>
                                                            ) : (
                                                                <div className="text-muted">No STL files selected.</div>
                                                            )}
                                                            {/* Add New STL Card */}
                                                            <div className="col-md-3 col-lg-3 ">
                                                                <div
                                                                    className="card h-100 shadow-sm"
                                                                    onClick={OpenModalFile}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        border: "2px solid rgba(0, 123, 255, 0.32)",
                                                                        borderRadius: "8px", // Optional: to make the corners rounded



                                                                        minHeight: "52vh",
                                                                        maxHeight: "52vh"
                                                                    }}
                                                                >
                                                                    <div className="card-body d-flex flex-column justify-content-center align-items-center">
                                                                        <div className="dz-message needsclick text-center">
                                                                            <center>
                                                                                <div className="mb-3">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-light"
                                                                                        style={{
                                                                                            borderRadius: "50%",
                                                                                            padding: "20px",
                                                                                            width: "60px",
                                                                                            height: "60px",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "center",
                                                                                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                                                                        }}
                                                                                    >
                                                                                        <i className="ri-add-line" style={{ fontSize: "32px" }}></i>
                                                                                    </button>
                                                                                </div>
                                                                            </center>
                                                                            <h5 className="text-muted mb-0">Upload STL File(s)</h5>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <hr className="my-4" />
                                                        <h5 className="mb-3">🧰 Mould Library Items</h5>
                                                        <div className="row">

                                                            {formData.moulds && formData.moulds.length > 0 ? (
                                                                formData.moulds.map((item, index) => (
                                                                    <div key={`mould-${index}`} className="col-md-3 col-lg-3 mb-4">
                                                                        <div
                                                                            className="card h-100 shadow-sm"
                                                                            style={{
                                                                                borderRadius: "8px",
                                                                                minHeight: "52vh",
                                                                                maxHeight: "52vh"
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="card-header d-flex justify-content-between align-items-center bg-light"
                                                                                style={{ height: "10vh", maxHeight: "10vh" }}
                                                                            >
                                                                                <span
                                                                                    className="fw-semibold small text-truncate"
                                                                                    style={{
                                                                                        maxWidth: "80%",
                                                                                        whiteSpace: "nowrap",
                                                                                        overflow: "hidden",
                                                                                        textOverflow: "ellipsis"
                                                                                    }}
                                                                                    title={item.filename}
                                                                                >
                                                                                    #{index + 1} - {item.filename}
                                                                                </span>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-outline-danger"
                                                                                    onClick={() => handleDeleteMould(index)}
                                                                                >
                                                                                    <i className="bx bx-trash"></i>
                                                                                </button>
                                                                            </div>

                                                                            <div className="card-body d-flex flex-column justify-content-between">
                                                                                <div className="row">
                                                                                    <div className="col-6 d-flex align-items-center justify-content-center" style={{ height: "13vh" }}>
                                                                                        {getFileExtension(item.urlfile) === "stl" ? (
                                                                                            <SimpleSTLViewer url={item.urlfile} currentColor={item.materials_color} />
                                                                                        ) : (
                                                                                            <img src={item.urlfile} alt="Selected File" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                                                                        )}
                                                                                    </div>

                                                                                    <div className="col-6">
                                                                                        <ul className="list-unstyled small mb-0">
                                                                                            <li><strong>Mould Type:</strong> <span>{item.mould_type}</span></li>
                                                                                            <li><strong>Created:</strong> <span>{vAdminformat.FormatDateTime(item.date_created)}</span></li>
                                                                                            <li><strong>Description:</strong> <span>{item.comment}</span></li>
                                                                                            <li><strong>Quantity:</strong> {item.qty}</li>
                                                                                            <li><strong>Material:</strong> <span className="text-break">{item.materialname}</span></li>
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="mt-auto">
                                                                                    <textarea
                                                                                        value={item.job_comment}
                                                                                        onChange={(e) => handleCommentMouldChange(e, index)}
                                                                                        className="form-control mt-3"
                                                                                        placeholder="Add instructions"
                                                                                        rows={2}
                                                                                        style={{ resize: "none" }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                ))
                                                            ) : (
                                                                <div className="text-muted">No moulds selected.</div>
                                                            )}
                                                            <div className="col-md-3 col-lg-3 mb-4">
                                                                <div
                                                                    className="card h-100 shadow-sm"
                                                                    onClick={OpenMouldModal}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        border: "2px solid rgba(0, 123, 255, 0.32)",
                                                                        borderRadius: "8px",
                                                                        minHeight: "52vh",
                                                                        maxHeight: "52vh"
                                                                    }}
                                                                >
                                                                    <div className="card-body d-flex flex-column justify-content-center align-items-center">
                                                                        <div className="dz-message needsclick">
                                                                            <center>
                                                                                <div className="mb-3">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-light"
                                                                                        style={{
                                                                                            borderRadius: "50%",
                                                                                            padding: "20px",
                                                                                            width: "60px",
                                                                                            height: "60px",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "center",
                                                                                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                                                                        }}
                                                                                    >
                                                                                        <i className="ri-file-4-line" style={{ fontSize: "32px" }}></i>
                                                                                    </button>
                                                                                </div>
                                                                            </center>
                                                                            <h5 className="text-muted mb-0">Choose from Mould Library</h5>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="d-flex align-items-start gap-3 mt-4">
                                                <button type="button" className="btn btn-light btn-label " onClick={() => goToTab('pills-bill-address')}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>Back to Shipping</button>
                                                <button type="button" className="btn btn-primary btn-label right ms-auto" onClick={() => {

                                                    const hasItems = formData.items?.length > 0;
                                                    const hasMoulds = formData.moulds?.length > 0;

                                                    if (hasItems || hasMoulds) {
                                                        goToTab('pills-summary');
                                                    } else {
                                                        Swal.fire({
                                                            icon: 'error',
                                                            title: 'You must select an STL file or a mould to see the summary and complete the order.',
                                                            showConfirmButton: false,
                                                            timer: 2000
                                                        });
                                                    }



                                                }
                                                }><i className="ri-shopping-basket-line label-icon align-middle fs-16 ms-2"
                                                ></i>Continue to summary</button>
                                            </div>

                                        </div>

                                        <div className={`tab-pane fade ${activeTabId === 'pills-summary' ? 'show active' : ''}`}
                                            id="pills-summary"
                                            role="tabpanel"
                                            aria-labelledby="pills-summary-tab">

                                            <div className="row">
                                                <div>
                                                    <h5 className="mb-1">Summary</h5>
                                                    <p className="text-muted mb-4">Please review all information before saving the transaction.</p>
                                                </div>
                                                <div className='col-12'>
                                                    <div className='row'>
                                                        <div className="col-6">
                                                            <div className="card p-3 mb-3" style={{ minHeight: '200px' }}>
                                                                <h6 className="fw-bold">Customer Information</h6>
                                                                <p className="text-muted mb-1"><strong>Customer Name:</strong> {formData.name}</p>
                                                                <p className="text-muted mb-1"><strong>Customer ID:</strong> {formData.cust_id}</p>
                                                                <p className="text-muted mb-1"><strong>Phone 1:</strong> {formData.phone}</p>
                                                                <p className="text-muted mb-1"><strong>Phone 2:</strong> {formData.phone2}</p>
                                                            </div>
                                                        </div>
                                                        {formData.address_choose === 0 ? (
                                                            <div className="col-6">
                                                                <div className="card p-3 mb-3" style={{ minHeight: '200px' }}>
                                                                    <h6 className="fw-bold">Address</h6>
                                                                    <p>{formData.name} {formData.lastname}</p>
                                                                    <span className="text-muted fw-normal text-wrap mb-1 d-block">
                                                                        {formData.address}, {formData.city}, {formData.zipcode}, {formData.country}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="col-6">
                                                                <div className="card p-3 mb-3" style={{ minHeight: '200px' }}>
                                                                    <h6 className="fw-bold">Address</h6>
                                                                    <p>{formData.name} {formData.lastname}</p>
                                                                    <span className="text-muted fw-normal text-wrap mb-1 d-block">
                                                                        {formData.shipping_address}, {formData.shipping_city}, {formData.shipping_zipcode}, {formData.shipping_country}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>
                                                <h5>📁 STL Files</h5>
                                                <div className='col-12'>
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th>File</th>
                                                                <th>Image</th>
                                                                <th>Data</th>
                                                                <th>Material</th>
                                                                <th>Quantity</th>
                                                                <th>Est. Price Breakdown</th>
                                                                <th>Special instructions</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData.items && formData.items.length > 0 ? (
                                                                formData.items.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <p style={{ marginBlock: "3.4vh" }}>{index + 1}</p>
                                                                        </td>
                                                                        <td>
                                                                            <p style={{ marginBlock: "3.4vh" }}>
                                                                                {item.filename}
                                                                            </p>
                                                                        </td>
                                                                        <td>
                                                                            <div style={{ height: "13vh", width: "13vh" }}>
                                                                                <SimpleSTLViewer url={item.urlfile} currentColor={item.materials_color} />
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ height: '80%' }}>
                                                                            <ul className="list-unstyled d-flex flex-column justify-content-between h-100">
                                                                                <li>
                                                                                    <span className="text-muted">Weight:</span> {item.weight}
                                                                                </li>
                                                                                <li>
                                                                                    <span className="text-muted">Volume:</span> {item.volume}
                                                                                </li>
                                                                                {/* <li>
                                                                                    <span className="text-muted">Area:</span> {item.area}
                                                                                </li> */}
                                                                                <li>
                                                                                    <span className="text-muted">Dimensions:</span> {item.dimensions}
                                                                                </li>
                                                                            </ul>
                                                                        </td>
                                                                        <td>
                                                                            <p style={{ marginBlock: "3.4vh" }}>{item.materialname}</p>
                                                                        </td>
                                                                        <td>
                                                                            <p style={{ marginBlock: "3.4vh" }}>{item.qty}</p>
                                                                        </td>
                                                                        <td style={{ height: '80%', minWidth: "28vh" }}>
                                                                            <ul className="list-unstyled d-flex flex-column justify-content-between h-100">
                                                                                {/*                                                                                <li>
                                                                                    <span className="text-muted">Print Charge:</span> £154.00
                                                                                </li>
                                                                                <li>
<span className="text-muted">Casting Charge:</span> £221.76
                                                                                </li>
                                                                                <li>
                                                                                    <span className="text-muted">Metal Charge:</span> £6455.23
</li>
                                                                                 */}
                                                                                <li>
                                                                                    <span >Price:</span> {vAdminformat.FormatMoney(item.price)}
                                                                                </li>

                                                                                <li>
                                                                                    <span >Discount:</span> {vAdminformat.FormatMoney(item.discount)}
                                                                                </li>
                                                                                <li>
                                                                                    <span className="fw-bold">Total:</span> {vAdminformat.FormatMoney(item.total)}
                                                                                </li>
                                                                            </ul>
                                                                        </td>
                                                                        <td>
                                                                            <span>{item.job_comment}</span>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="8">No files selected yet.</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>

                                                </div>
                                                <br />
                                                <h5>🧰 Mould Library Items</h5>
                                                <div className="col-12 row">
                                                    {formData.moulds && formData.moulds.length > 0 ? (
                                                        formData.moulds.map((item, index) => (
                                                            <div key={`mould-${index}`} className="col-md-3 col-lg-3 mb-4">
                                                                <div
                                                                    className="card h-100 shadow-sm bg-light"
                                                                    style={{
                                                                        borderRadius: "10px",
                                                                        border: "1px solid #dcdcdc",
                                                                        minHeight: "52vh",
                                                                        maxHeight: "52vh",
                                                                        backgroundColor: "#f8f9fa"
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="card-header d-flex justify-content-between align-items-center"
                                                                        style={{
                                                                            backgroundColor: "#e9ecef",
                                                                            borderBottom: "1px solid #ccc",
                                                                            height: "10vh",
                                                                            maxHeight: "10vh"
                                                                        }}
                                                                    >
                                                                        <span className="fw-semibold text-dark small">
                                                                            #{index + 1} - {item.filename}
                                                                        </span>
                                                                    </div>

                                                                    <div className="card-body d-flex flex-column justify-content-between">
                                                                        <div className="row">
                                                                            {/* STL Viewer */}
                                                                            <div
                                                                                className="col-6 d-flex align-items-center justify-content-center"
                                                                                style={{ height: "13vh" }}
                                                                            >
                                                                                {getFileExtension(item.urlfile) === "stl" ? (
                                                                                    <SimpleSTLViewer url={item.urlfile} currentColor={item.materials_color} />
                                                                                ) : (

                                                                                    <img src={item.urlfile} alt="Selected File" style={{ width: "100%", height: "100%", objectFit: "contain" }} />

                                                                                )}
                                                                            </div>

                                                                            {/* Info */}
                                                                            <div className="col-6">
                                                                                <ul className="list-unstyled small mb-0 text-muted">
                                                                                    <li><strong>Mossssuld Type:</strong> {item.mould_name}</li>
                                                                                    <li><strong>Created:</strong> {vAdminformat.FormatDateTime(item.date_created)}</li>
                                                                                    <li>
                                                                                        <strong>Description:</strong>
                                                                                        <div className="text-break">{item.comment}</div>
                                                                                    </li>
                                                                                    <li><strong>Quantity:</strong> {item.qty}</li>
                                                                                    <li><strong>Material:</strong> <span className="text-break">{item.materialname}</span></li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>

                                                                        {/* Comments */}
                                                                        <div className="mt-auto">
                                                                            <textarea
                                                                                value={item.job_comment}
                                                                                disabled
                                                                                className="form-control mt-3"
                                                                                placeholder="Add instructions"
                                                                                rows={2}
                                                                                style={{ resize: "none" }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="text-muted">No moulds selected.</div>
                                                    )}
                                                </div>
                                                <div className="row mt-3">
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <label htmlFor="jobComment">Description:</label>
                                                            <textarea
                                                                id="jobComment"
                                                                className="form-control"
                                                                value={formData.comment}
                                                                onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
                                                                placeholder="Add your comments here"
                                                                rows="5"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-start gap-3 mt-4">
                                                <button type="button" className="btn btn-light btn-label" onClick={() => goToTab('pills-payment')}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back to Shipping</button>
                                                <button type="button" className="btn btn-primary btn-label right ms-auto" onClick={InsertQuotations}><i className="ri-shopping-basket-line label-icon align-middle fs-16 ms-2"></i> Continue to Complete</button>
                                            </div>
                                        </div>

                                        <div className={`tab-pane fade ${activeTabId === 'pills-finish' ? 'show active' : ''}`}
                                            id="pills-finish"
                                            role="tabpanel"
                                            aria-labelledby="pills-finish-tab">
                                            {orderDetails.ID ? (
                                                <div className="text-center py-5">
                                                    <h3 className="fw-semibold">Instant Quote ID: <Link>{orderDetails.ID && orderDetails.ID}</Link></h3>

                                                    <br />
                                                    <br />
                                                    <Link className='btn btn-warning' to="/quotation" style={{ marginRight: "5px" }}>Return</Link>
                                                    <button className='btn btn-secondary' type='button' onClick={() => {
                                                        setOrderDetails([]) //To clean order details (qrcode)



                                                        goToTab('pills-bill-info')
                                                    }
                                                    }>New Instant Quote</button>
                                                </div>
                                            ) : (
                                                <div className="text-center py-5">

                                                    <h5>Sorry :(</h5>
                                                    <p className="text-muted">the order has not yet been completed.</p>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            {/*Modal for Billing Address */}
            <div className={`modal fade ${showModalBilling ? 'show' : ''}`} style={{ display: showModalBilling ? 'block' : 'none', backgroundColor: "#0000007a" }} tabindex="-1">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Billing Address</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseBillingModal}></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleBillingSubmit}>

                                <div className="mb-3">
                                    <label htmlFor="billingAddress" className="form-label">Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="billingAddress"
                                        value={formData.address}
                                        maxLength="256"
                                        onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                        required />
                                </div>
                                <div className="row">
                                    <div className="mb-3 col-6">
                                        <label htmlFor="billingCity" className="form-label">City</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="billingCity"
                                            value={formData.city}
                                            maxLength="50"
                                            onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                                            required />
                                    </div>
                                    <div className="mb-3 col-6">
                                        <label htmlFor="billingCountry" className="form-label">Country</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="billingCountry"
                                            maxLength="50"
                                            value={formData.country}
                                            onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                                            required />
                                    </div>
                                </div>
                                <div className="row">

                                    <div className="mb-3 col-12">
                                        <label htmlFor="billingZipcode" className="form-label">PostCode</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="billingZipcode"
                                            value={formData.zipcode}
                                            maxLength="50"
                                            onChange={(e) => setFormData({ ...formData, zipcode: e.target.value })}
                                            required />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary">Save changes</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/*Modal for Shipping Address */}
            <div className={`modal fade ${showModalShipping ? 'show' : ''}`} style={{ display: showModalShipping ? 'block' : 'none', backgroundColor: "#0000007a" }} tabindex="-1">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Shipping Address</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseShippingModal}></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleShippingSubmit}>
                                <div className="row">
                                    <div className="mb-3 col-12">
                                        <label htmlFor="shippingAddress" className="form-label">Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="shippingAddress"
                                            maxLength="256"
                                            value={formData.shipping_address}
                                            onChange={(e) => setFormData({ ...formData, shipping_address: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mb-3 col-6">
                                        <label htmlFor="shippingCity" className="form-label">City</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="shippingCity"
                                            value={formData.shipping_city}
                                            maxLength="50"
                                            onChange={(e) => setFormData({ ...formData, shipping_city: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3 col-6">
                                        <label htmlFor="shippingPhone" className="form-label">Shipping Country</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="shippingPhone"
                                            value={formData.shipping_country}
                                            onChange={(e) => setFormData({ ...formData, shipping_country: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3 col-12">
                                        <label htmlFor="shippingZipcode" className="form-label">PostCode</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="shippingZipcode"
                                            maxLength="50"
                                            value={formData.shipping_zipcode}
                                            onChange={(e) => setFormData({ ...formData, shipping_zipcode: e.target.value })}
                                        />
                                    </div>
                                </div>

                                <button type="submit" className="btn btn-primary">Save changes</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`modal fade ${fileUploadList ? 'show' : ''}`} style={{ display: fileUploadList ? 'block' : 'none', backgroundColor: "#0000007a" }} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="myExtraLargeModalLabel">{isUpdateJob === 1 ? "Update Job" : "Create Job"}</h5>
                            <button type="button" className="btn-close" onClick={closeModalFile} aria-label="Close"></button>
                        </div>
                        <div className="modal-body" style={{ minHeight: "80vh" }}>
                            <div id="paymentAccordion">
                                {isUpdateJob === 0 && (
                                    <div className="row">
                                        <div className="col-lg-4 col-sm-6">
                                            <div className="form-check card-radio">
                                                <input
                                                    id="paymentMethod01"
                                                    name="paymentMethod"
                                                    type="radio"
                                                    className="form-check-input"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#paymentmethodCollapseCustomerFile"
                                                    aria-expanded="false"
                                                    aria-controls="paymentmethodCollapseCustomerFile"
                                                    onClick={() => {
                                                        setSTLFileBussiness(null);
                                                        setConfUpload(false);
                                                        setIsPrivate(0)
                                                        setSelectedFiles([]);
                                                        setFormData({
                                                            ...formData,
                                                            volume: "",
                                                            area: "",
                                                            weight: "",
                                                            file_id: "",
                                                            dimensions: ""
                                                        });
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="paymentMethod01">
                                                    <span className="fs-16 text-muted me-2"><i className="ri-user-fill"></i></span>
                                                    <span className="fs-15 text-wrap"> My Files</span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="form-check card-radio">
                                                <input
                                                    id="paymentMethod02"
                                                    name="paymentMethod"
                                                    type="radio"
                                                    className="form-check-input"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#paymentmethodCollapseMyLibrary"
                                                    aria-expanded="false"
                                                    aria-controls="paymentmethodCollapseMyLibrary"
                                                    onClick={() => {
                                                        setSTLFileBussiness(null);
                                                        setConfUpload(false);
                                                        setSelectedFiles([]);
                                                        setIsPrivate(1);
                                                        setFormData({
                                                            ...formData,
                                                            volume: "",
                                                            area: "",
                                                            weight: "",
                                                            file_id: "",
                                                            dimensions: ""
                                                        });
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="paymentMethod02">
                                                    <span className="fs-16 text-muted me-2"><i className="ri-user-fill"></i></span>
                                                    <span className="fs-15 text-wrap">Print Folder</span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="form-check card-radio">
                                                <input
                                                    id="paymentMethod03"
                                                    name="paymentMethod"
                                                    type="radio"
                                                    className="form-check-input"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#paymentmethodCollapseUploadFile"
                                                    aria-expanded="false"
                                                    aria-controls="paymentmethodCollapseUploadFile"
                                                    onClick={() => {
                                                        setSTLFileBussiness(null);
                                                        setConfUpload(false);
                                                        setSelectedFiles([]);
                                                        setFormData({
                                                            ...formData,
                                                            volume: "",
                                                            area: "",
                                                            weight: "",
                                                            file_id: "",
                                                            dimensions: ""
                                                        });
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="paymentMethod03">
                                                    <span className="fs-16 text-muted me-2"><i className="ri-upload-2-line"></i></span>
                                                    <span className="fs-15 text-wrap">Upload File</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="collapse show" id="paymentmethodCollapseCustomerFile" data-bs-parent="#paymentAccordion">
                                    <div style={{ marginBlock: "1em" }}>
                                        {isUpdateJob === 0 && (
                                            <div className="mb-3 position-relative">
                                                <label htmlFor="select-existing-customer" className="form-label">My Library</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="select-existing-customer"
                                                    placeholder="Select or search for a File..."
                                                    autoComplete="off"
                                                    onFocus={() => setIsDropdownVisible(true)}
                                                    onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                    value={searchTerm}
                                                    style={{ zIndex: 1 }}
                                                />

                                                {isDropdownVisible && (
                                                    <div
                                                        className="dropdown-menu show w-100 shadow-sm"
                                                        style={{
                                                            position: "absolute",
                                                            top: "100%",
                                                            left: 0,
                                                            zIndex: 2,
                                                            maxHeight: '200px',
                                                            overflowY: 'auto',
                                                            border: '1px solid #ced4da',
                                                            borderTop: 'none',
                                                            borderRadius: '0 0 0.25rem 0.25rem'
                                                        }}
                                                    >
                                                        {filteredCustomerFiles && filteredCustomerFiles.length > 0 ? (
                                                            filteredCustomerFiles.map((CustomerFile) => (
                                                                <button
                                                                    className="dropdown-item"
                                                                    type="button"
                                                                    key={CustomerFile.file_ID}
                                                                    onClick={() => {
                                                                        handleFileSelect(CustomerFile);
                                                                        setFileURL(`${server_backend}/${CustomerFile.path_file}`);
                                                                        setSearchTerm(CustomerFile.name);
                                                                        setIsDropdownVisible(false);
                                                                    }}
                                                                >
                                                                    {CustomerFile.name}
                                                                </button>
                                                            ))
                                                        ) : (
                                                            <button className="dropdown-item" type="button" disabled>
                                                                No File found
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <div className="row">
                                            <div className="col-lg-6 col-md-12">
                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>
                                                            Selected File: {STLfileBussiness.name}
                                                        </p>
                                                        <div>
                                                            <STLViewerQuot
                                                                url={fileURL}
                                                                currentColor={selectedMaterialColor}
                                                                onStatsUpdate={handleStatsUpdate}
                                                                data={formData}
                                                                currentDencity={currentDencity}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-lg-6 col-md-12">
                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <>
                                                        <div className="mt-3">
                                                            <center>
                                                                <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Material</p>
                                                            </center>
                                                            <div
                                                                style={{
                                                                    minHeight: '23vh',
                                                                    height: '22vh',
                                                                    border: '1px solid #dcdcdc',
                                                                    padding: "20px",
                                                                    width: "100%",
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                {materialList && materialList.length > 0 ? (
                                                                    materialList.map((material) => (
                                                                        <button
                                                                            key={material.mat_ID}
                                                                            className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                                            type="button"
                                                                            onClick={() => {
                                                                                handleMaterialSelect(material);
                                                                                setSelectedMaterialColor(material.color);
                                                                                setCurrentDencity(material.density);
                                                                            }}
                                                                        >
                                                                            <div className="d-flex align-items-center">
                                                                                <ColorBox color={material.color} />
                                                                                <span className="ms-2">{material.name}</span>
                                                                            </div>
                                                                        </button>
                                                                    ))
                                                                ) : (
                                                                    <button className="dropdown-item" type="button" disabled>
                                                                        No materials found
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="mt-3">
                                                            <center>
                                                                <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Model Stats:</p>
                                                            </center>
                                                            <div className="table-responsive" style={{ width: '100%', height: '42vh', overflow: "hidden" }}>
                                                                <table className="table table-bordered" style={{ height: '23vh' }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="font-weight-bold">
                                                                                <h6>Weight (g):</h6>
                                                                            </td>
                                                                            <td className="text-end" style={{ width: "20%" }}>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control text-center small-input"
                                                                                    id="weightInput"
                                                                                    placeholder="Enter weight in grams"
                                                                                    value={formData.weight}
                                                                                    onChange={(e) => setFormData({ ...formData, weight: e.target.value })}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="font-weight-bold">
                                                                                <h6>Dimensions (mm):</h6>
                                                                            </td>
                                                                            <td className="text-end">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control text-center small-input"
                                                                                    id="dimensionsInput"
                                                                                    placeholder="Enter dimensions in mm"
                                                                                    value={formData.dimensions}
                                                                                    onChange={(e) => setFormData({ ...formData, dimensions: e.target.value })}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="collapse" id="paymentmethodCollapseMyLibrary" data-bs-parent="#paymentAccordion">
                                    <div style={{ marginBlock: "1em" }}>
                                        <div className="mb-3 position-relative">
                                            <label htmlFor="select-existing-customer" className="form-label">
                                                Print Folder
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="select-existing-customer"
                                                placeholder="Select or search for a File..."
                                                autoComplete="off"
                                                onFocus={() => setIsDropdownVisible(true)}
                                                onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                value={searchTerm}
                                            />

                                            {isDropdownVisible && (
                                                <div
                                                    className="dropdown-menu show w-100 shadow-sm"
                                                    style={{
                                                        maxHeight: "200px",
                                                        overflowY: "auto",
                                                        position: "absolute",
                                                        top: "100%",
                                                        left: "0",
                                                        zIndex: 1000,
                                                        borderRadius: "0 0 0.375rem 0.375rem", // Soft rounded bottom



                                                        borderTop: "none", // Seamless transition



                                                    }}
                                                >
                                                    {filteredFiles.length > 0 ? (
                                                        filteredFiles.map((bussinessFile) => (
                                                            <button
                                                                className="dropdown-item"
                                                                type="button"
                                                                key={bussinessFile.file_ID}
                                                                onClick={() => {
                                                                    handleFileSelect(bussinessFile);
                                                                    setSearchTerm(bussinessFile.name);
                                                                    setFileURL(`${server_backend}/${bussinessFile.path_file}`);
                                                                    setIsDropdownVisible(false);
                                                                }}
                                                            >
                                                                {bussinessFile.name}
                                                            </button>
                                                        ))
                                                    ) : (
                                                        <button className="dropdown-item" type="button" disabled>
                                                            No File found
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-12">
                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Selected File: {STLfileBussiness.name}</p>
                                                        <div>
                                                            <STLViewerQuot url={fileURL} currentColor={selectedMaterialColor} onStatsUpdate={handleStatsUpdate} data={formData} currentDencity={currentDencity} />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <center>
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Material</p>
                                                        </center>
                                                        <div
                                                            style={{
                                                                minHeight: '23vh',
                                                                height: '22vh',
                                                                border: '1px solid #dcdcdc',
                                                                padding: "20px",
                                                                width: "100%",
                                                                overflowY: 'auto',
                                                            }}
                                                        >
                                                            {materialList && materialList.length > 0 ? (
                                                                materialList.map((material) => (
                                                                    <button
                                                                        key={material.mat_ID}
                                                                        className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                                        type="button"
                                                                        onClick={() => {

                                                                            handleMaterialSelect(material);
                                                                            setSelectedMaterialColor(material.color);
                                                                            setCurrentDencity(material.density);


                                                                        }}
                                                                    >
                                                                        <div className="d-flex align-items-center">
                                                                            <ColorBox color={material.color} />
                                                                            <span className="ms-2">{material.name}</span>
                                                                        </div>
                                                                    </button>
                                                                ))
                                                            ) : (
                                                                <button className="dropdown-item" type="button" disabled>
                                                                    No materials found
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <center>
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Model Stats:</p>
                                                        </center>
                                                        <div className="table-responsive" style={{ width: '100%', height: '42vh', overflow: "hidden" }}>
                                                            <table className="table table-bordered" style={{ height: '23vh' }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="font-weight-bold">
                                                                            <h6>Weight (g):</h6>
                                                                        </td>
                                                                        <td className="text-end" style={{ width: "20%" }}>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center small-input"
                                                                                id="weightInput"
                                                                                placeholder="Enter weight in grams"
                                                                                value={formData.weight}
                                                                                onChange={(e) => {
                                                                                    setFormData({ ...formData, weight: e.target.value });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="font-weight-bold">
                                                                            <h6>Dimensions (mm):</h6>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control text-center small-input"
                                                                                id="dimensionsInput"
                                                                                placeholder="Enter dimensions in mm"
                                                                                value={formData.dimensions}
                                                                                onChange={(e) => {
                                                                                    setFormData({ ...formData, dimensions: e.target.value });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>

                                                                </tbody>

                                                            </table>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>

                                        </div>


                                    </div>
                                </div>

                                <div className="collapse" id="paymentmethodCollapseUploadFile" data-bs-parent="#paymentAccordion">

                                    {ConfUpload ? (
                                        AliasFileName.length > 0 && (
                                            <div
                                                className="alert alert-success alert-dismissible fade show"
                                                style={{ marginBlock: "2em" }}
                                                role="alert"
                                            >
                                                <strong>The files have been successfully uploaded!</strong> You can locate them in the 'Print Folder' under the names:{" "}
                                                <strong>
                                                    {AliasFileName.join(", ")}
                                                </strong>.
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    data-bs-dismiss="alert"
                                                    aria-label="Close"
                                                ></button>
                                            </div>
                                        )
                                    ) : (
                                        <div style={{ marginBlock: "2em" }}>
                                            <div>
                                                <label htmlFor="formFile" className="form-label">Upload Your Files</label>
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    id="formFile"
                                                    accept=".stl"
                                                    multiple
                                                    onChange={handleFileChange}
                                                />
                                            </div>

                                            {selectedFiles.length > 0 && (
                                                <div className="mt-3">
                                                    <h6>Selected Files:</h6>
                                                    <ul className="list-group">
                                                        {selectedFiles.map((file, index) => (
                                                            <li
                                                                key={index}
                                                                className="list-group-item d-flex justify-content-between align-items-center"
                                                            >
                                                                {file.name}
                                                                <span className="badge bg-primary rounded-pill">
                                                                    {Math.round(file.size / 1024)} KB
                                                                </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}

                                            {isUploading && (
                                                <div className="progress mt-3">
                                                    <div
                                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                                        role="progressbar"
                                                        aria-valuenow={uploadProgress}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                        style={{ width: `${uploadProgress}%` }}
                                                    >
                                                        {uploadProgress}%
                                                    </div>
                                                </div>
                                            )}

                                            <div className="mt-3">
                                                <button
                                                    className="btn btn-primary w-100"
                                                    onClick={handleUploadFileModal}
                                                    disabled={isUploading}
                                                >
                                                    {isUploading ? 'Uploading...' : 'Upload and Save'}
                                                </button>
                                            </div>
                                        </div>

                                    )}
                                </div>
                                {(STLfileBussiness && STLfileBussiness.name) && (
                                    <div className="row">
                                        {/*Quantity Field */}
                                        <div className="col-3 d-flex flex-column">
                                            <label htmlFor="quantityInput" className="form-label">Quantity</label>
                                            <div className="input-step d-flex align-items-center w-100">
                                                <button
                                                    type="button"
                                                    className="minus"
                                                    onClick={() => handleDecreaseQuantity()}
                                                >
                                                    –
                                                </button>

                                                <input
                                                    id="quantityInput"
                                                    type="number"
                                                    className="text-center mx-2 product-quantity w-100"
                                                    value={formData.qty ?? 1}
                                                    min="0"
                                                    max="100"
                                                    onChange={(e) =>
                                                        setFormData({ ...formData, qty: Number(e.target.value) })
                                                    }
                                                />

                                                <button
                                                    type="button"
                                                    className="plus btn btn-light"
                                                    onClick={() => handleIncreaseQuantity()}
                                                >
                                                    +
                                                </button>
                                            </div>

                                        </div>

                                        {/*Price Field */}
                                        <div className="col-3 d-flex flex-column">
                                            <label htmlFor="priceInput" className="form-label">Price</label>

                                            <input type="number" class="form-control" value={currentPrice} required
                                                onChange={handlePriceChange} />
                                        </div>

                                        {/* Discount */}

                                        <div className="col-3 d-flex flex-column">
                                            <label htmlFor="priceInput" className="form-label">Discount</label>
                                            <div className="input-group">
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    id="cart-discount"

                                                    onKeyUp={(e) => {

                                                        let value = 0;

                                                        if (e.target.value == '') {
                                                            value = 0;
                                                            e.target.value = 0;
                                                            setFormData({ ...formData, discount: value });
                                                        } else {
                                                            e.target.value = parseInt(e.target.value);
                                                            setFormData({ ...formData, discount: parseInt(e.target.value) });
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {/*Total Field */}
                                        <div className="col-3 d-flex flex-column">
                                            <label htmlFor="totalInput" className="form-label">Total</label>
                                            <input
                                                type="text"
                                                className="form-control text-center"
                                                id="totalInput"
                                                value={vAdminformat.FormatMoney(
                                                    ((Number(currentPrice) * Number(formData.qty || 0))
                                                        + Number(formData.print_charge || 0))
                                                    - Number(formData.discount || 0)
                                                )}

                                                readOnly
                                                disabled
                                            />
                                        </div>

                                        <div>
                                            <h5 style={{ paddingBlock: "18px" }}>Additional Information</h5>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="optjc_id" className="form-label">3D Print</label>
                                                        <select
                                                            className="form-select"
                                                            aria-label=".form-select-sm example"
                                                            name="optjc_id"
                                                            value={formData.print_type || 0}
                                                            onChange={(e) => setFormData({ ...formData, print_type: e.target.value })}
                                                        ><option>Select the option</option>
                                                            {[...new Map(
                                                                optionJobs
                                                                    .filter(option => option.optjc_ID === 1)
                                                                    .map(option => [option.name, option])
                                                            ).values()].map(uniqueOption => (
                                                                <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                    {uniqueOption.name}
                                                                </option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="optjc_id" className="form-label">Print Charge (£)</label>
                                                        <div className="position-relative">
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Enter amount or select an option"
                                                                value={formData.print_charge || ""}
                                                                onKeyDown={() => setShowOptions(false)}
                                                                onChange={(e) => {
                                                                    const charge = parseFloat(e.target.value) || 0;
                                                                    const discount = parseFloat(formData.discount_ptg) || 0;
                                                                    const discountedValue = charge - (charge * (discount / 100));

                                                                    setFormData({
                                                                        ...formData,
                                                                        print_charge: discountedValue.toFixed(2),
                                                                    });
                                                                }}
                                                                onFocus={() => setShowOptions(true)}
                                                            />

                                                            {showOptions && (
                                                                <div
                                                                    className="dropdown-menu show position-absolute w-100 mt-1"
                                                                    style={{
                                                                        maxHeight: "200px",
                                                                        overflowY: "auto",
                                                                        zIndex: 1050,
                                                                    }}
                                                                >
                                                                    {[...new Map(
                                                                        optionJobs
                                                                            .filter(option => option.optjc_ID === 2)
                                                                            .map(option => [option.name, option])
                                                                    ).values()].map((uniqueOption) => (
                                                                        <button
                                                                            key={uniqueOption.optjc_ID}
                                                                            className="dropdown-item"
                                                                            type="button"
                                                                            onClick={() => {
                                                                                const charge = parseFloat(uniqueOption.value) || 0;
                                                                                const discount = parseFloat(formData.discount_ptg) || 0;
                                                                                const discountedValue = charge - (charge * (discount / 100));

                                                                                setFormData({
                                                                                    ...formData,
                                                                                    print_charge: discountedValue.toFixed(2),
                                                                                });
                                                                                setShowOptions(false);
                                                                            }}
                                                                        >
                                                                            {uniqueOption.name}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="optjc_id" className="form-label">Print Discount (%)</label>
                                                        <select
                                                            className="form-select"
                                                            aria-label=".form-select-sm example"
                                                            name="optjc_id"
                                                            value={formData.discount_ptg || ""}
                                                            onChange={(e) => {
                                                                const discount = parseFloat(e.target.value) || 0;
                                                                const charge = parseFloat(formData.print_charge) || 0;

                                                                const discountedValue = charge - (charge * (discount / 100));

                                                                setFormData({
                                                                    ...formData,
                                                                    discount_ptg: discount,
                                                                    print_charge: discountedValue.toFixed(2),
                                                                });
                                                            }}
                                                        >
                                                            <option>Select the option</option>
                                                            {[...new Map(
                                                                optionJobs
                                                                    .filter(option => option.optjc_ID === 3)
                                                                    .map(option => [option.name, option])
                                                            ).values()].map(uniqueOption => (
                                                                <option key={uniqueOption.optjc_ID} value={uniqueOption.value}>
                                                                    {uniqueOption.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="optjc_id" className="form-label">Moulding</label>
                                                        <select
                                                            className="form-select"
                                                            aria-label=".form-select-sm example"
                                                            name="optjc_id"
                                                            value={formData.moulding || 0}
                                                            onChange={(e) => setFormData({ ...formData, moulding: e.target.value })}
                                                        ><option>Select the option</option>
                                                            {[...new Map(
                                                                optionJobs
                                                                    .filter(option => option.optjc_ID === 4)
                                                                    .map(option => [option.name, option])
                                                            ).values()].map(uniqueOption => (
                                                                <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                    {uniqueOption.name}
                                                                </option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="optjc_id" className="form-label">Mould Only</label>
                                                        <select
                                                            className="form-select"
                                                            aria-label=".form-select-sm example"
                                                            name="optjc_id"
                                                            value={formData.mould_only || 0}
                                                            onChange={(e) => setFormData({ ...formData, mould_only: e.target.value })}
                                                        ><option>Select the option</option>
                                                            {[...new Map(
                                                                optionJobs
                                                                    .filter(option => option.optjc_ID === 5)
                                                                    .map(option => [option.name, option])
                                                            ).values()].map(uniqueOption => (
                                                                <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                    {uniqueOption.name}
                                                                </option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="expectedDate" className="form-label">
                                                            Expected Cast Date
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            id="expectedDate"
                                                            name="expectedDate"
                                                            value={formData.date_estimated}
                                                            onChange={(e) =>
                                                                setFormData({ ...formData, date_estimated: e.target.value })
                                                            }
                                                            required
                                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                                        />
                                                    </div>

                                                </div>


                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="optjc_id" className="form-label">Sprue Master</label>
                                                        <select
                                                            className="form-select"
                                                            aria-label=".form-select-sm example"
                                                            name="optjc_id"
                                                            value={formData.sprue_master}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setFormData((prevFormData) => ({
                                                                    ...prevFormData,
                                                                    sprue_master: value,
                                                                    ...(value == 0 && { sprue_material: 0, sprue_feed: 0 })
                                                                }));
                                                            }}

                                                        >
                                                            <option value={0}>Select the option</option>

                                                            {[...new Map(
                                                                optionJobs
                                                                    .filter(option => option.optjc_ID === 6)
                                                                    .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate



                                                            ).values()].map(uniqueOption => (
                                                                <option key={uniqueOption.optjc_ID} value={uniqueOption.value}>
                                                                    {uniqueOption.name}
                                                                </option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="optjc_id" className="form-label">Sprue Material</label>
                                                        <select
                                                            className="form-select"
                                                            aria-label=".form-select-sm example"
                                                            name="optjc_id"
                                                            value={formData.sprue_material}
                                                            onChange={(e) => setFormData({ ...formData, sprue_material: e.target.value })}
                                                            disabled={formData.sprue_master == 1 ? false : true}
                                                        ><option>Select the option</option>
                                                            {[...new Map(
                                                                optionJobs
                                                                    .filter(option => option.optjc_ID === 7)
                                                                    .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate



                                                            ).values()].map(uniqueOption => (
                                                                <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                    {uniqueOption.name}
                                                                </option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="optjc_id" className="form-label">Metal</label>
                                                        <select
                                                            className="form-select"
                                                            aria-label=".form-select-sm example"
                                                            name="optjc_id"
                                                            value={formData.sprue_feed}
                                                            onChange={(e) => setFormData({ ...formData, sprue_feed: e.target.value })}
                                                            disabled={formData.sprue_master == 1 ? false : true}
                                                        ><option>Select the option</option>
                                                            {[...new Map(
                                                                optionJobs
                                                                    .filter(option => option.optjc_ID === 8)
                                                                    .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate



                                                            ).values()].map(uniqueOption => (
                                                                <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                    {uniqueOption.name}
                                                                </option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="optjc_id" className="form-label">Post</label>
                                                        <select
                                                            className="form-select"
                                                            aria-label=".form-select-sm example"
                                                            name="optjc_id"
                                                            value={formData.post}
                                                            onChange={(e) => setFormData({ ...formData, post: e.target.value })}
                                                        ><option>Select the option</option>
                                                            {[...new Map(
                                                                optionJobs
                                                                    .filter(option => option.optjc_ID === 9)
                                                                    .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate



                                                            ).values()].map(uniqueOption => (
                                                                <option key={uniqueOption.optjc_ID} value={uniqueOption.optjv_ID}>
                                                                    {uniqueOption.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="quantityInput" className="form-label">Injection Wax Quantity</label>
                                                    <div className="input-step d-flex align-items-center w-100">
                                                        <button type="button" className="minus btn btn-light" onClick={() => handleDecreaseWaxQuantity()}>–</button>
                                                        <input
                                                            type="number"
                                                            className="form-control text-center mx-2 product-quantity w-100"
                                                            value={formData.wax_qty ? formData.wax_qty : 0}
                                                            min="0"
                                                            max="100"
                                                        />

                                                        <button type="button" className="plus btn btn-light" onClick={() => handleIncreaseWaxQuantity()}>+</button>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="name" className="form-label">Quantity or Designate </label>
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="name"
                                                                name="name"
                                                                value={formData.designate}
                                                                onChange={(e) => setFormData({ ...formData, designate: e.target.value })}
                                                                required
                                                            />

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {(STLfileBussiness && STLfileBussiness.name) && (
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label htmlFor="jobComment">Comments:</label>
                                                <textarea
                                                    id="jobComment"
                                                    className="form-control"
                                                    value={formData.job_comment}
                                                    onChange={(e) => setFormData({ ...formData, job_comment: e.target.value })}
                                                    placeholder="Add your comments here"
                                                    rows="5"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {(STLfileBussiness && STLfileBussiness.name) && (
                                    <div className="col-12">
                                        <div className="card border-light shadow-sm mb-3" style={{ marginBlock: "10px", border: '1px solid #dcdcdc' }}>
                                            <div className="card-body d-flex justify-content-end align-items-center flex-wrap">

                                                <button
                                                    className="btn btn-primary w-25"
                                                    onClick={addFileToItems}
                                                >
                                                    Save
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className={`modal fade ${isOpenMouldModal ? 'show' : ''}`}
                style={{ display: isOpenMouldModal ? 'block' : 'none', backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered modal-sm" style={{ maxWidth: "40%" }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add injected wax media from your library to your Quote</h5>
                            <button type="button" className="btn-close" onClick={closeMouldModal} aria-label="Close"></button>
                        </div>
                        <div className="modal-body" style={{ minHeight: "80vh" }}>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <label className="form-label fw-bold text-muted">Mould library</label>
                                    <div className="position-relative w-100">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="select-existing-customer"
                                            placeholder="Select or search for a File..."
                                            onFocus={() => setIsDropdownVisible(true)}
                                            onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)} // hide after slight delay


                                            onChange={(e) => setSearchMouldTerm(e.target.value)}
                                            value={searchMouldTerm}
                                            autoComplete="off"
                                            style={{
                                                zIndex: 2,
                                                position: 'relative',
                                                borderRadius: isDropdownVisible ? '0.375rem 0.375rem 0 0' : '0.375rem',
                                            }}
                                        />
                                        {isDropdownVisible && (
                                            <div
                                                className="dropdown-menu show w-100"
                                                style={{
                                                    maxHeight: '200px',
                                                    overflowY: 'auto',
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    zIndex: 1,
                                                    borderTop: 'none',
                                                    borderRadius: '0 0 0.375rem 0.375rem',
                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                {filteredMouldFiles && filteredMouldFiles.length > 0 ? (
                                                    filteredMouldFiles.map((mould) => (
                                                        <button
                                                            className="dropdown-item"
                                                            type="button"
                                                            key={mould.file_ID}
                                                            onClick={() => {
                                                                handleFileSelect(mould);
                                                                setIsDropdownVisible(false);
                                                                setSearchMouldTerm(mould.mould_name);
                                                                setFileURL(`${server_backend}/${mould.path_file}`);
                                                            }}
                                                        >
                                                            {mould.mould_name}
                                                        </button>
                                                    ))
                                                ) : (
                                                    <button className="dropdown-item" type="button" disabled>
                                                        No File found
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                </div>

                                <div className="col-12 mb-3">
                                    <label className="form-label fw-bold text-muted">Metal</label>
                                    <div
                                        style={{
                                            minHeight: '14vh',
                                            height: '14vh',
                                            border: '1px solid #dcdcdc',
                                            padding: "5px",
                                            width: "100%",
                                            overflowY: 'auto',
                                        }}
                                    >
                                        {materialList && materialList.length > 0 ? (
                                            materialList.map((material) => (
                                                <button
                                                    key={material.mat_ID}
                                                    className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                    type="button"
                                                    onClick={() => {
                                                        handleMaterialSelect(material);
                                                        setSelectedMaterialColor(material.color);
                                                        setCurrentDencity(material.density);


                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <ColorBox color={material.color} />
                                                        <span className="ms-2">{material.name}</span>
                                                    </div>
                                                </button>
                                            ))
                                        ) : (
                                            <button className="dropdown-item" type="button" disabled>
                                                No materials found
                                            </button>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 mb-3">
                                    <label className="form-label fw-bold text-muted">Qty</label>
                                    <div className="input-step d-flex align-items-center w-100">
                                        <button
                                            type="button"
                                            className="minus"
                                            onClick={() => handleDecreaseQuantity()}
                                        >
                                            –
                                        </button>
                                        <input
                                            type="number"
                                            className="text-center mx-2 product-quantity w-100"
                                            value={formData.qty || 1}
                                            min="0"
                                            max="100"
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    qty: Math.max(0, parseInt(e.target.value) || 1),
                                                })
                                            }
                                        />
                                        <button
                                            type="button"
                                            className="plus btn btn-light"
                                            onClick={() => handleIncreaseQuantity()}
                                        >
                                            +
                                        </button>
                                    </div>

                                </div>

                                <div className="col-12 mb-3">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="me-3">
                                                <div style={{ height: "25vh", width: "40vh" }}>
                                                    {getFileExtension(fileURL) === "stl" ? (
                                                        <SimpleSTLViewer url={fileURL} />
                                                    ) : (
                                                        fileURL && (
                                                            <img src={fileURL} alt="Selected File" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div style={{
                                                height: "25vh", width: "40vh", maxWidth: "100%",
                                                maxHeight: "100%",
                                                border: "1px solid #dcdcdc",
                                                padding: "2px"
                                            }}>
                                                <center><h6 className="text-muted">Description</h6></center>
                                                <p className="mb-0 text-muted fs-100 m-2 mt-3">
                                                    Mould type: {STLfileBussiness?.mould_type}<br />
                                                    Mould created: {vAdminformat.FormatDateTime(STLfileBussiness?.date_created)}<br />
                                                    {STLfileBussiness?.comment}<br />
                                                    {/*  Material: Steel<br /> */}
                                                    Size: {STLfileBussiness?.mould_size}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 text-end">
                                    <button className="btn btn-info text-white" onClick={() => {

                                        if (!STLfileBussiness || !STLfileBussiness.file_ID) {
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Oops...',
                                                text: 'Please select a file from your library',
                                                confirmButtonText: 'OK',
                                                confirmButtonColor: '#007bff',
                                                customClass: {
                                                    confirmButton: 'btn btn-primary',
                                                },
                                            });
                                            return;
                                        } else {
                                            addMouldToItems()
                                        }

                                    }}
                                    >Add to quote</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className={`modal fade ${selectModalCustomer ? 'show' : ''}`} style={{ display: selectModalCustomer ? 'block' : 'none', backgroundColor: "#0000007a" }} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <center>
                                <h5 className="modal-title" id="myExtraLargeModalLabel">Select Existing Customer</h5>
                            </center>
                            <button type="button" className="btn-close" onClick={closeModalCustomer} aria-label="Close"></button>
                        </div>
                        <div className="modal-body" style={{ minHeight: "80vh" }}>
                            <div>
                                <div className="mb-3 " ref={dropdownRef}>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="input-light">
                                                    <p className='p-0 m-0 text-muted'>Find by</p>
                                                    <select
                                                        className="form-control custom-select-style"
                                                        name="choices-single-default"
                                                        value={filterBy} //Change to filterby



                                                        onChange={handleFilterByChange}
                                                    >
                                                        <option value="">Filter by</option>
                                                        <option value="cust_ID">ID</option>
                                                        <option value="fullname">Full name</option>
                                                        <option value="email">Email</option>
                                                        <option value="phone">Phone</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <p className='p-0 m-0 text-muted'>Search For</p>
                                                <div className='mb-3'>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="select-existing-customer"
                                                        onKeyUp={handleFilterValueChange}
                                                        onFocus={() => setShowDropdown(true)}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <button
                                        type='button'
                                        className={`d-flex text-start justify-content-between w-100 mb-2`}
                                        style={{
                                            padding: '10px 15px',
                                            borderRadius: '6px',
                                            border: '0px solid #dcdcdc',
                                        }}
                                    >
                                        <div className="col-1 text-center">

                                        </div>
                                        <div className="col-1">
                                            <span>ID</span>
                                        </div>

                                        <div className="col-md-3">
                                            <span>Name</span>
                                        </div>
                                        <div className="col-md-3">
                                            <span>Email</span>
                                        </div>
                                        <div className="col-md-2">
                                            <span>Phone</span>
                                        </div>
                                    </button>
                                    <div className="mt-2" style={{ maxHeight: '250px', overflowY: 'auto', padding: "15px", border: '1px solid #dcdcdc', backgroundColor: '#fff' }}>
                                        {CustomerList.length > 0 ? (
                                            CustomerList.map((customer) => (
                                                <button
                                                    key={customer.cust_ID}
                                                    type='button'
                                                    className={`d-flex text-start justify-content-between w-100 mb-2 ${temporaryCustomer?.cust_ID === customer.cust_ID ? 'bg-primary text-white shadow-sm' : ''}`}
                                                    style={{
                                                        padding: '10px 15px',
                                                        borderRadius: '6px',
                                                        border: '0px solid #dcdcdc',
                                                        backgroundColor: temporaryCustomer?.cust_ID === customer.cust_ID ? '#007bff' : '#fff',
                                                        color: temporaryCustomer?.cust_ID === customer.cust_ID ? '#fff' : '#333',
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                                                    }}
                                                    onClick={() => handleCustomerSelect(customer)}
                                                >
                                                    <div className="col-1 text-center">
                                                        <input
                                                            type="radio"
                                                            name="selectedCustomer"
                                                            checked={temporaryCustomer?.cust_ID === customer.cust_ID}
                                                            onChange={() => handleCustomerSelect(customer)}
                                                        />
                                                    </div>
                                                    <div className="col-1">
                                                        <span>{customer.cust_ID}</span>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <span>{customer.fullname}</span>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <span>{customer.email}</span>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <span>{customer.phone}</span>
                                                    </div>
                                                </button>
                                            ))
                                        ) : (
                                            <div className="text-center">No customers found</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex">
                                <button type="button" className="btn btn-primary ms-auto" onClick={confirmCustomerSelect}>
                                    Select
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className={`modal fade ${createModalCustomer ? 'show' : ''}`} style={{ display: createModalCustomer ? 'block' : 'none', backgroundColor: "#0000007a" }} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <center>
                                <h5 className="modal-title" id="myExtraLargeModalLabel">Create Customer</h5>
                            </center>
                            <div className='d-flex justify-content-end'>
                                <button className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                    closeCreateModalCustomer()
                                    cleanParameters() //clean parametres is importan to formData



                                }}>
                                    Discard
                                </button>
                                <button className="btn btn-primary" type="submit" disabled={loading} onClick={handleCreate}>
                                    {loading ? "Creating..." : "Create"}
                                </button>
                            </div>
                        </div>
                        <div className="modal-body" style={{ minHeight: "80vh" }} >
                            <form onSubmit={handleCreate}>
                                <div className="row">
                                    {/*Personal Information */}
                                    <form>
                                        <div className="card mb-3">
                                            <div className="card-header">
                                                <h5>User Information</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="row mb-3">
                                                    <div className="col-sm-6">
                                                        <label htmlFor="name" className="form-label">Name</label>
                                                        <input type="text" className="form-control" id="name" name="name" value={formDataCustomer.name} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, name: e.target.value })} />
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <label htmlFor="lastname" className="form-label">Lastname</label>
                                                        <input type="text" className="form-control" id="lastname" name="lastname" value={formDataCustomer.lastname} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, lastname: e.target.value })} />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-sm-6">
                                                        <label htmlFor="phone" className="form-label">Phone</label>
                                                        <input type="text" className="form-control" id="phone" name="phone" value={formDataCustomer.phone} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, phone: e.target.value })} />
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <label htmlFor="phone2" className="form-label">Secondary Phone</label>
                                                        <input type="text" className="form-control" id="phone2" name="phone2" value={formDataCustomer.phone2} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, phone2: e.target.value })} />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-sm-6">
                                                        <label htmlFor="email" className="form-label">Email</label>
                                                        <input type="email" className="form-control" id="email" name="email" value={formDataCustomer.email} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, email: e.target.value })} />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="card mb-3">
                                            <div className="card-body">
                                                <div className="row mb-3">
                                                    <div className="col-sm-6">
                                                        <center><h5 className="card-title mb-3">Billing address </h5></center>
                                                        <label htmlFor="address" className="form-label">Address</label>
                                                        <input type="text" className="form-control" id="address" name="address" value={formDataCustomer.address} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, address: e.target.value })} />
                                                        <label htmlFor="City" className="form-label">City</label>
                                                        <input type="text" className="form-control" id="city" name="city" value={formDataCustomer.city} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, city: e.target.value })} />
                                                        <label htmlFor="country" className="form-label">Country</label>
                                                        <input type="text" className="form-control" id="country" name="country" value={formDataCustomer.country} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, country: e.target.value })} />
                                                        <label htmlFor="zipcode" className="form-label">Postcode</label>
                                                        <input type="text" className="form-control" id="zipcode" name="zipcode" value={formDataCustomer.zipcode} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, zipcode: e.target.value })} />
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <center><h5 className="card-title mb-3">Shipping address</h5></center>
                                                        <label htmlFor="shipping_address" className="form-label">Address</label>
                                                        <input type="text" className="form-control" id="shipping_address" name="shipping_address" value={formDataCustomer.shipping_address} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, shipping_address: e.target.value })} />
                                                        <label htmlFor="shipping_city" className="form-label">City</label>
                                                        <input type="text" className="form-control" id="shipping_city" name="shipping_city" value={formDataCustomer.shipping_city} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, shipping_city: e.target.value })} />
                                                        <label htmlFor="shipping_country" className="form-label">Country</label>
                                                        <input type="text" className="form-control" id="shipping_country" name="shipping_country" value={formDataCustomer.shipping_country} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, shipping_country: e.target.value })} />
                                                        <label htmlFor="shipping_zipcode" className="form-label">Postcode</label>
                                                        <input type="text" className="form-control" id="shipping_zipcode" name="shipping_zipcode" value={formDataCustomer.shipping_zipcode} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, shipping_zipcode: e.target.value })} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card mb-3">
                                            <div className="card-body">
                                                <div className="row mb-3">
                                                    <div className="col-sm-6">
                                                        <center><h5 className="card-title mb-3">Contact Information</h5></center>
                                                        <label htmlFor="contact_fullname" className="form-label">Contact Full Name</label>

                                                        <input type="text" className="form-control" id="contact_fullname" name="contact_fullname" value={formDataCustomer.contact_fullname} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, contact_fullname: e.target.value })} />

                                                        <label htmlFor="contact_phone" className="form-label">Contact Phone</label>
                                                        <input type="text" className="form-control" id="contact_phone" name="contact_phone" value={formDataCustomer.contact_phone} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, contact_phone: e.target.value })} />

                                                        <label htmlFor="contact_email" className="form-label">Contact Email</label>
                                                        <input type="email" className="form-control" id="contact_email" name="contact_email" value={formDataCustomer.contact_email} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, contact_email: e.target.value })} />
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <center><h5 className="card-title mb-3">References</h5></center>
                                                        <label htmlFor="reference1" className="form-label">Reference 1</label>
                                                        <input type="text" className="form-control" id="reference1" name="reference1" value={formDataCustomer.reference1} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, reference1: e.target.value })} />
                                                        <label htmlFor="reference2" className="form-label">Reference 2</label>
                                                        <input type="text" className="form-control" id="reference2" name="reference2" value={formDataCustomer.reference2} onChange={(e) => setFormDataCustomer({ ...formDataCustomer, reference2: e.target.value })} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="comment" className="form-label">Comment</label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter comment"
                                            name="comment"
                                            value={formDataCustomer.comment}
                                            onChange={(e) => setFormDataCustomer({ ...formDataCustomer, comment: e.target.value })}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end'>
                                    <button className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                        closeCreateModalCustomer()
                                        cleanParameters() //clean parametres is importan to formData



                                    }}>
                                        Discard
                                    </button>
                                    <button className="btn btn-primary" type="submit" disabled={loading}>
                                        {loading ? "Creating..." : "Create"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default CreateQuotation;
